(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', 'kotlin', 'kvision-js-legacy', 'snabbdom'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('kotlin'), require('kvision-js-legacy'), require('snabbdom'));
  else {
    if (typeof kotlin === 'undefined') {
      throw new Error("Error loading module 'kvision-kvision-bootstrap-js-legacy'. Its dependency 'kotlin' was not found. Please, check whether 'kotlin' is loaded prior to 'kvision-kvision-bootstrap-js-legacy'.");
    }if (typeof this['kvision-js-legacy'] === 'undefined') {
      throw new Error("Error loading module 'kvision-kvision-bootstrap-js-legacy'. Its dependency 'kvision-js-legacy' was not found. Please, check whether 'kvision-js-legacy' is loaded prior to 'kvision-kvision-bootstrap-js-legacy'.");
    }if (typeof snabbdom === 'undefined') {
      throw new Error("Error loading module 'kvision-kvision-bootstrap-js-legacy'. Its dependency 'snabbdom' was not found. Please, check whether 'snabbdom' is loaded prior to 'kvision-kvision-bootstrap-js-legacy'.");
    }root['kvision-kvision-bootstrap-js-legacy'] = factory(typeof this['kvision-kvision-bootstrap-js-legacy'] === 'undefined' ? {} : this['kvision-kvision-bootstrap-js-legacy'], kotlin, this['kvision-js-legacy'], snabbdom);
  }
}(this, function (_, Kotlin, $module$kvision_js_legacy, $module$snabbdom) {
  'use strict';
  var $$importsForInline$$ = _.$$importsForInline$$ || (_.$$importsForInline$$ = {});
  var Unit = Kotlin.kotlin.Unit;
  var Kind_OBJECT = Kotlin.Kind.OBJECT;
  var ModuleInitializer = $module$kvision_js_legacy.io.kvision.ModuleInitializer;
  var Enum = Kotlin.kotlin.Enum;
  var Kind_CLASS = Kotlin.Kind.CLASS;
  var CssClass = $module$kvision_js_legacy.io.kvision.core.CssClass;
  var throwISE = Kotlin.throwISE;
  var joinToString = Kotlin.kotlin.collections.joinToString_fmv235$;
  var Object_init = Object;
  var createInstance = $module$kvision_js_legacy.io.kvision.utils.createInstance_aevmdv$;
  var get_px = $module$kvision_js_legacy.io.kvision.utils.get_px_s8ev3n$;
  var numberToInt = Kotlin.numberToInt;
  var SimplePanel = $module$kvision_js_legacy.io.kvision.panel.SimplePanel;
  var Display = $module$kvision_js_legacy.io.kvision.core.Display;
  var utils = $module$kvision_js_legacy.io.kvision.utils;
  var Root = $module$kvision_js_legacy.io.kvision.panel.Root;
  var DomAttribute = $module$kvision_js_legacy.io.kvision.core.DomAttribute;
  var PropertyMetadata = Kotlin.PropertyMetadata;
  var equals = Kotlin.equals;
  var Link = $module$kvision_js_legacy.io.kvision.html.Link;
  var ButtonStyle = $module$kvision_js_legacy.io.kvision.html.ButtonStyle;
  var Widget$Widget$RefreshDelegateProvider_init = $module$kvision_js_legacy.io.kvision.core.Widget.RefreshDelegateProvider;
  var collectionSizeOrDefault = Kotlin.kotlin.collections.collectionSizeOrDefault_ba2ldo$;
  var ArrayList_init = Kotlin.kotlin.collections.ArrayList_init_ww73n8$;
  var throwCCE = Kotlin.throwCCE;
  var ClassSetBuilder = $module$kvision_js_legacy.io.kvision.core.ClassSetBuilder;
  var Button = $module$kvision_js_legacy.io.kvision.html.Button;
  var AttributeSetBuilder = $module$kvision_js_legacy.io.kvision.core.AttributeSetBuilder;
  var ButtonType = $module$kvision_js_legacy.io.kvision.html.ButtonType;
  var TAG = $module$kvision_js_legacy.io.kvision.html.TAG;
  var Tag = $module$kvision_js_legacy.io.kvision.html.Tag;
  var CheckBox = $module$kvision_js_legacy.io.kvision.form.check.CheckBox;
  var CheckBoxInput = $module$kvision_js_legacy.io.kvision.form.check.CheckBoxInput;
  var set = $module$kvision_js_legacy.io.kvision.snabbdom.set_dzr37t$;
  var Widget = $module$kvision_js_legacy.io.kvision.core.Widget;
  var Span = $module$kvision_js_legacy.io.kvision.html.Span;
  var span = $module$kvision_js_legacy.io.kvision.html.span_f4ecwj$;
  var Container = $module$kvision_js_legacy.io.kvision.core.Container;
  var IntRange = Kotlin.kotlin.ranges.IntRange;
  var toString = Kotlin.toString;
  var WidgetWrapper = $module$kvision_js_legacy.io.kvision.core.WidgetWrapper;
  var LinkedHashMap_init = Kotlin.kotlin.collections.LinkedHashMap_init_q3lmfv$;
  var JsMath = Math;
  var ensureNotNull = Kotlin.ensureNotNull;
  var routing = $module$kvision_js_legacy.io.kvision.routing;
  var Icon = $module$kvision_js_legacy.io.kvision.html.Icon;
  var isBlank = Kotlin.kotlin.text.isBlank_gw00vp$;
  var ArrayList_init_0 = Kotlin.kotlin.collections.ArrayList_init_287e2$;
  var copyToArray = Kotlin.kotlin.collections.copyToArray;
  var getOrNull = Kotlin.kotlin.collections.getOrNull_yzln2o$;
  var Pair = Kotlin.kotlin.Pair;
  var toIntOrNull = Kotlin.kotlin.text.toIntOrNull_pdl1vz$;
  var getCallableRef = Kotlin.getCallableRef;
  var numberToDouble = Kotlin.numberToDouble;
  var Kind_INTERFACE = Kotlin.Kind.INTERFACE;
  var ObservableValue = $module$kvision_js_legacy.io.kvision.state.ObservableValue;
  var Div = $module$kvision_js_legacy.io.kvision.html.Div;
  var get_perc = $module$kvision_js_legacy.io.kvision.utils.get_perc_rcaex3$;
  var to = Kotlin.kotlin.to_ujzrz7$;
  var listOf = Kotlin.kotlin.collections.listOf_mh5how$;
  var h = $module$snabbdom.h;
  var listOf_0 = Kotlin.kotlin.collections.listOf_i5x0yv$;
  var emptySet = Kotlin.kotlin.collections.emptySet_287e2$;
  var simplePanel = $module$kvision_js_legacy.io.kvision.panel.simplePanel_jhiteo$;
  var kvision = $module$kvision_js_legacy.io.kvision;
  var roundToInt = Kotlin.kotlin.math.roundToInt_yrwdxr$;
  var Resize = $module$kvision_js_legacy.io.kvision.core.Resize;
  var UNIT = $module$kvision_js_legacy.io.kvision.core.UNIT;
  var Overflow = $module$kvision_js_legacy.io.kvision.core.Overflow;
  BsBgColor.prototype = Object.create(Enum.prototype);
  BsBgColor.prototype.constructor = BsBgColor;
  Placement.prototype = Object.create(Enum.prototype);
  Placement.prototype.constructor = Placement;
  Trigger.prototype = Object.create(Enum.prototype);
  Trigger.prototype.constructor = Trigger;
  ContextMenu.prototype = Object.create(SimplePanel.prototype);
  ContextMenu.prototype.constructor = ContextMenu;
  DD.prototype = Object.create(Enum.prototype);
  DD.prototype.constructor = DD;
  Direction.prototype = Object.create(Enum.prototype);
  Direction.prototype.constructor = Direction;
  AutoClose.prototype = Object.create(Enum.prototype);
  AutoClose.prototype.constructor = AutoClose;
  DropDown.prototype = Object.create(SimplePanel.prototype);
  DropDown.prototype.constructor = DropDown;
  DropDownButton.prototype = Object.create(Button.prototype);
  DropDownButton.prototype.constructor = DropDownButton;
  DropDownMenu.prototype = Object.create(SimplePanel.prototype);
  DropDownMenu.prototype.constructor = DropDownMenu;
  Header.prototype = Object.create(Tag.prototype);
  Header.prototype.constructor = Header;
  Separator.prototype = Object.create(SimplePanel.prototype);
  Separator.prototype.constructor = Separator;
  Modal.prototype = Object.create(SimplePanel.prototype);
  Modal.prototype.constructor = Modal;
  Alert.prototype = Object.create(Modal.prototype);
  Alert.prototype.constructor = Alert;
  CloseIcon.prototype = Object.create(Widget.prototype);
  CloseIcon.prototype.constructor = CloseIcon;
  Confirm.prototype = Object.create(Modal.prototype);
  Confirm.prototype.constructor = Confirm;
  ModalSize.prototype = Object.create(Enum.prototype);
  ModalSize.prototype.constructor = ModalSize;
  ModalDialog.prototype = Object.create(SimplePanel.prototype);
  ModalDialog.prototype.constructor = ModalDialog;
  Nav.prototype = Object.create(SimplePanel.prototype);
  Nav.prototype.constructor = Nav;
  NavForm.prototype = Object.create(Tag.prototype);
  NavForm.prototype.constructor = NavForm;
  NavbarColor.prototype = Object.create(Enum.prototype);
  NavbarColor.prototype.constructor = NavbarColor;
  NavbarExpand.prototype = Object.create(Enum.prototype);
  NavbarExpand.prototype.constructor = NavbarExpand;
  Navbar.prototype = Object.create(SimplePanel.prototype);
  Navbar.prototype.constructor = Navbar;
  NavbarButton.prototype = Object.create(SimplePanel.prototype);
  NavbarButton.prototype.constructor = NavbarButton;
  Cell.prototype = Object.create(Tag.prototype);
  Cell.prototype.constructor = Cell;
  Scope.prototype = Object.create(Enum.prototype);
  Scope.prototype.constructor = Scope;
  HeaderCell.prototype = Object.create(Tag.prototype);
  HeaderCell.prototype.constructor = HeaderCell;
  Row.prototype = Object.create(Tag.prototype);
  Row.prototype.constructor = Row;
  TableType.prototype = Object.create(Enum.prototype);
  TableType.prototype.constructor = TableType;
  ResponsiveType.prototype = Object.create(Enum.prototype);
  ResponsiveType.prototype.constructor = ResponsiveType;
  Table.prototype = Object.create(SimplePanel.prototype);
  Table.prototype.constructor = Table;
  ButtonGroup.prototype = Object.create(SimplePanel.prototype);
  ButtonGroup.prototype.constructor = ButtonGroup;
  Toolbar.prototype = Object.create(SimplePanel.prototype);
  Toolbar.prototype.constructor = Toolbar;
  function BootstrapModule() {
    BootstrapModule_instance = this;
    this.bootstrap_8be2vx$ = null;
    var tmp$;
    (tmp$ = document.body) != null ? (tmp$.setAttribute('data-bs-no-jquery', 'true'), Unit) : null;
    this.bootstrap_8be2vx$ = require('bootstrap');
  }
  BootstrapModule.prototype.initialize = function () {
  };
  BootstrapModule.$metadata$ = {kind: Kind_OBJECT, simpleName: 'BootstrapModule', interfaces: [ModuleInitializer]};
  var BootstrapModule_instance = null;
  function BootstrapModule_getInstance() {
    if (BootstrapModule_instance === null) {
      new BootstrapModule();
    }return BootstrapModule_instance;
  }
  var BsBorder$BORDER_instance;
  var BsBorder$BORDERTOP_instance;
  var BsBorder$BORDERBOTTOM_instance;
  var BsBorder$BORDERRIGHT_instance;
  var BsBorder$BORDERLEFT_instance;
  var BsBorder$BORDER_0_instance;
  var BsBorder$BORDERTOP_0_instance;
  var BsBorder$BORDERBOTTOM_0_instance;
  var BsBorder$BORDERRIGHT_0_instance;
  var BsBorder$BORDERLEFT_0_instance;
  var BsBorder$BORDERPRIMARY_instance;
  var BsBorder$BORDERSECONDARY_instance;
  var BsBorder$BORDERSUCCESS_instance;
  var BsBorder$BORDERDANGER_instance;
  var BsBorder$BORDERWARNING_instance;
  var BsBorder$BORDERINFO_instance;
  var BsBorder$BORDERLIGHT_instance;
  var BsBorder$BORDERDARK_instance;
  var BsBorder$BORDERWHITE_instance;
  var BsRounded$ROUNDED_instance;
  var BsRounded$ROUNDEDTOP_instance;
  var BsRounded$ROUNDEDBOTTOM_instance;
  var BsRounded$ROUNDEDLEFT_instance;
  var BsRounded$ROUNDEDRIGHT_instance;
  var BsRounded$ROUNDEDCIRCLE_instance;
  var BsRounded$ROUNDEDPILL_instance;
  var BsRounded$ROUNDEDLG_instance;
  var BsRounded$ROUNDEDSM_instance;
  var BsRounded$ROUNDED0_instance;
  var BsRounded$ROUNDED1_instance;
  var BsRounded$ROUNDED2_instance;
  var BsRounded$ROUNDED3_instance;
  var BsRounded$ROUNDED4_instance;
  var BsRounded$ROUNDED5_instance;
  var BsColor$PRIMARY_instance;
  var BsColor$SECONDARY_instance;
  var BsColor$SUCCESS_instance;
  var BsColor$DANGER_instance;
  var BsColor$WARNING_instance;
  var BsColor$INFO_instance;
  var BsColor$LIGHT_instance;
  var BsColor$DARK_instance;
  var BsColor$WHITE_instance;
  var BsColor$BODY_instance;
  var BsColor$MUTED_instance;
  var BsColor$BLACK50_instance;
  var BsColor$WHITE50_instance;
  var BsColor$PRIMARYBG_instance;
  var BsColor$SECONDARYBG_instance;
  var BsColor$SUCCESSBG_instance;
  var BsColor$DANGERBG_instance;
  var BsColor$WARNINGBG_instance;
  var BsColor$INFOBG_instance;
  var BsColor$LIGHTBG_instance;
  var BsColor$DARKBG_instance;
  function BsBgColor(name, ordinal, className) {
    Enum.call(this);
    this.className_pa4h24$_0 = className;
    this.name$ = name;
    this.ordinal$ = ordinal;
  }
  function BsBgColor_initFields() {
    BsBgColor_initFields = function () {
    };
    BsBgColor$PRIMARY_instance = new BsBgColor('PRIMARY', 0, 'bg-primary');
    BsBgColor$SECONDARY_instance = new BsBgColor('SECONDARY', 1, 'bg-secondary');
    BsBgColor$SUCCESS_instance = new BsBgColor('SUCCESS', 2, 'bg-success');
    BsBgColor$DANGER_instance = new BsBgColor('DANGER', 3, 'bg-danger');
    BsBgColor$WARNING_instance = new BsBgColor('WARNING', 4, 'bg-warning');
    BsBgColor$INFO_instance = new BsBgColor('INFO', 5, 'bg-info');
    BsBgColor$LIGHT_instance = new BsBgColor('LIGHT', 6, 'bg-light');
    BsBgColor$DARK_instance = new BsBgColor('DARK', 7, 'bg-dark');
    BsBgColor$WHITE_instance = new BsBgColor('WHITE', 8, 'bg-white');
    BsBgColor$TRANSPARENT_instance = new BsBgColor('TRANSPARENT', 9, 'bg-transparent');
  }
  Object.defineProperty(BsBgColor.prototype, 'className', {get: function () {
    return this.className_pa4h24$_0;
  }});
  var BsBgColor$PRIMARY_instance;
  function BsBgColor$PRIMARY_getInstance() {
    BsBgColor_initFields();
    return BsBgColor$PRIMARY_instance;
  }
  var BsBgColor$SECONDARY_instance;
  function BsBgColor$SECONDARY_getInstance() {
    BsBgColor_initFields();
    return BsBgColor$SECONDARY_instance;
  }
  var BsBgColor$SUCCESS_instance;
  function BsBgColor$SUCCESS_getInstance() {
    BsBgColor_initFields();
    return BsBgColor$SUCCESS_instance;
  }
  var BsBgColor$DANGER_instance;
  function BsBgColor$DANGER_getInstance() {
    BsBgColor_initFields();
    return BsBgColor$DANGER_instance;
  }
  var BsBgColor$WARNING_instance;
  function BsBgColor$WARNING_getInstance() {
    BsBgColor_initFields();
    return BsBgColor$WARNING_instance;
  }
  var BsBgColor$INFO_instance;
  function BsBgColor$INFO_getInstance() {
    BsBgColor_initFields();
    return BsBgColor$INFO_instance;
  }
  var BsBgColor$LIGHT_instance;
  function BsBgColor$LIGHT_getInstance() {
    BsBgColor_initFields();
    return BsBgColor$LIGHT_instance;
  }
  var BsBgColor$DARK_instance;
  function BsBgColor$DARK_getInstance() {
    BsBgColor_initFields();
    return BsBgColor$DARK_instance;
  }
  var BsBgColor$WHITE_instance;
  function BsBgColor$WHITE_getInstance() {
    BsBgColor_initFields();
    return BsBgColor$WHITE_instance;
  }
  var BsBgColor$TRANSPARENT_instance;
  function BsBgColor$TRANSPARENT_getInstance() {
    BsBgColor_initFields();
    return BsBgColor$TRANSPARENT_instance;
  }
  BsBgColor.$metadata$ = {kind: Kind_CLASS, simpleName: 'BsBgColor', interfaces: [CssClass, Enum]};
  function BsBgColor$values() {
    return [BsBgColor$PRIMARY_getInstance(), BsBgColor$SECONDARY_getInstance(), BsBgColor$SUCCESS_getInstance(), BsBgColor$DANGER_getInstance(), BsBgColor$WARNING_getInstance(), BsBgColor$INFO_getInstance(), BsBgColor$LIGHT_getInstance(), BsBgColor$DARK_getInstance(), BsBgColor$WHITE_getInstance(), BsBgColor$TRANSPARENT_getInstance()];
  }
  BsBgColor.values = BsBgColor$values;
  function BsBgColor$valueOf(name) {
    switch (name) {
      case 'PRIMARY':
        return BsBgColor$PRIMARY_getInstance();
      case 'SECONDARY':
        return BsBgColor$SECONDARY_getInstance();
      case 'SUCCESS':
        return BsBgColor$SUCCESS_getInstance();
      case 'DANGER':
        return BsBgColor$DANGER_getInstance();
      case 'WARNING':
        return BsBgColor$WARNING_getInstance();
      case 'INFO':
        return BsBgColor$INFO_getInstance();
      case 'LIGHT':
        return BsBgColor$LIGHT_getInstance();
      case 'DARK':
        return BsBgColor$DARK_getInstance();
      case 'WHITE':
        return BsBgColor$WHITE_getInstance();
      case 'TRANSPARENT':
        return BsBgColor$TRANSPARENT_getInstance();
      default:throwISE('No enum constant io.kvision.core.BsBgColor.' + name);
    }
  }
  BsBgColor.valueOf_61zpoe$ = BsBgColor$valueOf;
  function Placement(name, ordinal, placement) {
    Enum.call(this);
    this.placement_8be2vx$ = placement;
    this.name$ = name;
    this.ordinal$ = ordinal;
  }
  function Placement_initFields() {
    Placement_initFields = function () {
    };
    Placement$AUTO_instance = new Placement('AUTO', 0, 'auto');
    Placement$TOP_instance = new Placement('TOP', 1, 'top');
    Placement$BOTTOM_instance = new Placement('BOTTOM', 2, 'bottom');
    Placement$LEFT_instance = new Placement('LEFT', 3, 'left');
    Placement$RIGHT_instance = new Placement('RIGHT', 4, 'right');
  }
  var Placement$AUTO_instance;
  function Placement$AUTO_getInstance() {
    Placement_initFields();
    return Placement$AUTO_instance;
  }
  var Placement$TOP_instance;
  function Placement$TOP_getInstance() {
    Placement_initFields();
    return Placement$TOP_instance;
  }
  var Placement$BOTTOM_instance;
  function Placement$BOTTOM_getInstance() {
    Placement_initFields();
    return Placement$BOTTOM_instance;
  }
  var Placement$LEFT_instance;
  function Placement$LEFT_getInstance() {
    Placement_initFields();
    return Placement$LEFT_instance;
  }
  var Placement$RIGHT_instance;
  function Placement$RIGHT_getInstance() {
    Placement_initFields();
    return Placement$RIGHT_instance;
  }
  Placement.$metadata$ = {kind: Kind_CLASS, simpleName: 'Placement', interfaces: [Enum]};
  function Placement$values() {
    return [Placement$AUTO_getInstance(), Placement$TOP_getInstance(), Placement$BOTTOM_getInstance(), Placement$LEFT_getInstance(), Placement$RIGHT_getInstance()];
  }
  Placement.values = Placement$values;
  function Placement$valueOf(name) {
    switch (name) {
      case 'AUTO':
        return Placement$AUTO_getInstance();
      case 'TOP':
        return Placement$TOP_getInstance();
      case 'BOTTOM':
        return Placement$BOTTOM_getInstance();
      case 'LEFT':
        return Placement$LEFT_getInstance();
      case 'RIGHT':
        return Placement$RIGHT_getInstance();
      default:throwISE('No enum constant io.kvision.core.Placement.' + name);
    }
  }
  Placement.valueOf_61zpoe$ = Placement$valueOf;
  function Trigger(name, ordinal, trigger) {
    Enum.call(this);
    this.trigger_8be2vx$ = trigger;
    this.name$ = name;
    this.ordinal$ = ordinal;
  }
  function Trigger_initFields() {
    Trigger_initFields = function () {
    };
    Trigger$CLICK_instance = new Trigger('CLICK', 0, 'click');
    Trigger$HOVER_instance = new Trigger('HOVER', 1, 'hover');
    Trigger$FOCUS_instance = new Trigger('FOCUS', 2, 'focus');
    Trigger$MANUAL_instance = new Trigger('MANUAL', 3, 'manual');
  }
  var Trigger$CLICK_instance;
  function Trigger$CLICK_getInstance() {
    Trigger_initFields();
    return Trigger$CLICK_instance;
  }
  var Trigger$HOVER_instance;
  function Trigger$HOVER_getInstance() {
    Trigger_initFields();
    return Trigger$HOVER_instance;
  }
  var Trigger$FOCUS_instance;
  function Trigger$FOCUS_getInstance() {
    Trigger_initFields();
    return Trigger$FOCUS_instance;
  }
  var Trigger$MANUAL_instance;
  function Trigger$MANUAL_getInstance() {
    Trigger_initFields();
    return Trigger$MANUAL_instance;
  }
  Trigger.$metadata$ = {kind: Kind_CLASS, simpleName: 'Trigger', interfaces: [Enum]};
  function Trigger$values() {
    return [Trigger$CLICK_getInstance(), Trigger$HOVER_getInstance(), Trigger$FOCUS_getInstance(), Trigger$MANUAL_getInstance()];
  }
  Trigger.values = Trigger$values;
  function Trigger$valueOf(name) {
    switch (name) {
      case 'CLICK':
        return Trigger$CLICK_getInstance();
      case 'HOVER':
        return Trigger$HOVER_getInstance();
      case 'FOCUS':
        return Trigger$FOCUS_getInstance();
      case 'MANUAL':
        return Trigger$MANUAL_getInstance();
      default:throwISE('No enum constant io.kvision.core.Trigger.' + name);
    }
  }
  Trigger.valueOf_61zpoe$ = Trigger$valueOf;
  function TooltipOptions(title, rich, animation, delay, hideDelay, placement, triggers, sanitize) {
    if (title === void 0)
      title = null;
    if (rich === void 0)
      rich = null;
    if (animation === void 0)
      animation = null;
    if (delay === void 0)
      delay = null;
    if (hideDelay === void 0)
      hideDelay = null;
    if (placement === void 0)
      placement = null;
    if (triggers === void 0)
      triggers = null;
    if (sanitize === void 0)
      sanitize = null;
    this.title = title;
    this.rich = rich;
    this.animation = animation;
    this.delay = delay;
    this.hideDelay = hideDelay;
    this.placement = placement;
    this.triggers = triggers;
    this.sanitize = sanitize;
  }
  TooltipOptions.$metadata$ = {kind: Kind_CLASS, simpleName: 'TooltipOptions', interfaces: []};
  TooltipOptions.prototype.component1 = function () {
    return this.title;
  };
  TooltipOptions.prototype.component2 = function () {
    return this.rich;
  };
  TooltipOptions.prototype.component3 = function () {
    return this.animation;
  };
  TooltipOptions.prototype.component4 = function () {
    return this.delay;
  };
  TooltipOptions.prototype.component5 = function () {
    return this.hideDelay;
  };
  TooltipOptions.prototype.component6 = function () {
    return this.placement;
  };
  TooltipOptions.prototype.component7 = function () {
    return this.triggers;
  };
  TooltipOptions.prototype.component8 = function () {
    return this.sanitize;
  };
  TooltipOptions.prototype.copy_9214e9$ = function (title, rich, animation, delay, hideDelay, placement, triggers, sanitize) {
    return new TooltipOptions(title === void 0 ? this.title : title, rich === void 0 ? this.rich : rich, animation === void 0 ? this.animation : animation, delay === void 0 ? this.delay : delay, hideDelay === void 0 ? this.hideDelay : hideDelay, placement === void 0 ? this.placement : placement, triggers === void 0 ? this.triggers : triggers, sanitize === void 0 ? this.sanitize : sanitize);
  };
  TooltipOptions.prototype.toString = function () {
    return 'TooltipOptions(title=' + Kotlin.toString(this.title) + (', rich=' + Kotlin.toString(this.rich)) + (', animation=' + Kotlin.toString(this.animation)) + (', delay=' + Kotlin.toString(this.delay)) + (', hideDelay=' + Kotlin.toString(this.hideDelay)) + (', placement=' + Kotlin.toString(this.placement)) + (', triggers=' + Kotlin.toString(this.triggers)) + (', sanitize=' + Kotlin.toString(this.sanitize)) + ')';
  };
  TooltipOptions.prototype.hashCode = function () {
    var result = 0;
    result = result * 31 + Kotlin.hashCode(this.title) | 0;
    result = result * 31 + Kotlin.hashCode(this.rich) | 0;
    result = result * 31 + Kotlin.hashCode(this.animation) | 0;
    result = result * 31 + Kotlin.hashCode(this.delay) | 0;
    result = result * 31 + Kotlin.hashCode(this.hideDelay) | 0;
    result = result * 31 + Kotlin.hashCode(this.placement) | 0;
    result = result * 31 + Kotlin.hashCode(this.triggers) | 0;
    result = result * 31 + Kotlin.hashCode(this.sanitize) | 0;
    return result;
  };
  TooltipOptions.prototype.equals = function (other) {
    return this === other || (other !== null && (typeof other === 'object' && (Object.getPrototypeOf(this) === Object.getPrototypeOf(other) && (Kotlin.equals(this.title, other.title) && Kotlin.equals(this.rich, other.rich) && Kotlin.equals(this.animation, other.animation) && Kotlin.equals(this.delay, other.delay) && Kotlin.equals(this.hideDelay, other.hideDelay) && Kotlin.equals(this.placement, other.placement) && Kotlin.equals(this.triggers, other.triggers) && Kotlin.equals(this.sanitize, other.sanitize)))));
  };
  function toJs$lambda(it) {
    return it.trigger_8be2vx$;
  }
  function toJs($receiver) {
    var tmp$;
    var trigger = (tmp$ = $receiver.triggers) != null ? joinToString(tmp$, ' ', void 0, void 0, void 0, void 0, toJs$lambda) : null;
    var $receiver_0 = new Object_init();
    if ($receiver.title != null)
      $receiver_0.title = $receiver.title;
    if ($receiver.rich != null)
      $receiver_0.html = $receiver.rich;
    if ($receiver.animation != null)
      $receiver_0.animation = $receiver.animation;
    if ($receiver.delay != null && $receiver.hideDelay != null) {
      var $receiver_1 = new Object_init();
      $receiver_1.show = $receiver.delay;
      $receiver_1.hide = $receiver.hideDelay;
      $receiver_0.delay = $receiver_1;
    } else if ($receiver.delay != null) {
      $receiver_0.delay = $receiver.delay;
    } else if ($receiver.hideDelay != null) {
      var $receiver_2 = new Object_init();
      $receiver_2.show = 0;
      $receiver_2.hide = $receiver.hideDelay;
      $receiver_0.delay = $receiver_2;
    }if ($receiver.placement != null)
      $receiver_0.placement = $receiver.placement.placement_8be2vx$;
    if (trigger != null)
      $receiver_0.trigger = trigger;
    if ($receiver.sanitize != null)
      $receiver_0.sanitize = $receiver.sanitize;
    return $receiver_0;
  }
  function createBsInstance($receiver, constructor, args) {
    var tmp$;
    return (tmp$ = $receiver.getElement()) != null ? createInstance(constructor(BootstrapModule_getInstance().bootstrap_8be2vx$), [tmp$].concat(args)) : null;
  }
  function getBsInstance($receiver, constructor) {
    var tmp$;
    return (tmp$ = $receiver.getElement()) != null ? constructor(BootstrapModule_getInstance().bootstrap_8be2vx$).getInstance(tmp$) : null;
  }
  function enableTooltip$lambda($receiver) {
    return $receiver.Tooltip;
  }
  function enableTooltip$lambda$lambda($receiver) {
    return $receiver.Tooltip;
  }
  function enableTooltip$lambda_0(this$enableTooltip, closure$options) {
    return function (it) {
      var tmp$, tmp$_0, tmp$_1;
      if (this$enableTooltip.tooltipOptions != null) {
        tmp$_0 = this$enableTooltip.tooltipOptions;
        var tmp$_2;
        tmp$_2 = (tmp$ = closure$options.title) != null ? this$enableTooltip.translate_61zpoe$(tmp$) : null;
        tmp$_1 = toJs(tmp$_0.copy_9214e9$(tmp$_2));
        createBsInstance(this$enableTooltip, enableTooltip$lambda$lambda, [tmp$_1]);
      }return Unit;
    };
  }
  function enableTooltip$lambda$lambda_0($receiver) {
    return $receiver.Tooltip;
  }
  function enableTooltip$lambda_1(this$enableTooltip) {
    return function () {
      var tmp$;
      if (this$enableTooltip.tooltipOptions != null) {
        (tmp$ = getBsInstance(this$enableTooltip, enableTooltip$lambda$lambda_0)) != null ? tmp$.dispose() : null;
      }return Unit;
    };
  }
  function enableTooltip($receiver, options) {
    if (options === void 0)
      options = new TooltipOptions();
    var tmp$;
    disablePopover($receiver);
    $receiver.tooltipOptions = options;
    createBsInstance($receiver, enableTooltip$lambda, [toJs(options.copy_9214e9$((tmp$ = options.title) != null ? $receiver.translate_61zpoe$(tmp$) : null))]);
    if (!$receiver.tooltipHooksActive) {
      $receiver.addAfterInsertHook_tcd33s$(enableTooltip$lambda_0($receiver, options));
      $receiver.addAfterDestroyHook_o14v8n$(enableTooltip$lambda_1($receiver));
      $receiver.tooltipHooksActive = true;
    }return $receiver;
  }
  function hideTooltip$lambda($receiver) {
    return $receiver.Tooltip;
  }
  function hideTooltip($receiver) {
    var tmp$;
    if ($receiver.tooltipOptions != null)
      (tmp$ = getBsInstance($receiver, hideTooltip$lambda)) != null ? tmp$.hide() : null;
    return $receiver;
  }
  function disableTooltip$lambda($receiver) {
    return $receiver.Tooltip;
  }
  function disableTooltip($receiver) {
    var tmp$;
    if ($receiver.tooltipOptions != null) {
      $receiver.tooltipOptions = null;
      (tmp$ = getBsInstance($receiver, disableTooltip$lambda)) != null ? tmp$.dispose() : null;
    }return $receiver;
  }
  function disablePopover$lambda($receiver) {
    return $receiver.Popover;
  }
  function disablePopover($receiver) {
    var tmp$;
    if ($receiver.popoverOptions != null) {
      $receiver.popoverOptions = null;
      (tmp$ = getBsInstance($receiver, disablePopover$lambda)) != null ? tmp$.dispose() : null;
    }return $receiver;
  }
  function ContextMenu(element, fixedPosition, className, init) {
    ContextMenu$Companion_getInstance();
    if (element === void 0)
      element = null;
    if (fixedPosition === void 0)
      fixedPosition = false;
    if (className === void 0)
      className = null;
    if (init === void 0)
      init = null;
    var tmp$;
    SimplePanel.call(this, ((tmp$ = className != null ? className + ' ' : null) != null ? tmp$ : '') + 'dropdown-menu');
    this.fixedPosition = fixedPosition;
    var tmp$_0;
    this.hide();
    this.display = Display.BLOCK;
    this.width = utils.auto;
    var root = (tmp$_0 = element != null ? element.getRoot() : null) != null ? tmp$_0 : Root.Companion.getLastRoot();
    if (root != null) {
      root.addContextMenu_y7t574$(this);
    } else {
      console.log('At least one Root object is required to create a context menu!');
    }
    init != null ? init(this) : null;
  }
  ContextMenu.prototype.positionMenu_tfvzir$ = function (mouseEvent) {
    if (this.fixedPosition) {
      this.top = get_px(5);
      this.left = get_px(5);
    } else {
      this.top = get_px(numberToInt(mouseEvent.pageY));
      this.left = get_px(numberToInt(mouseEvent.pageX));
    }
    this.show();
    return this;
  };
  function ContextMenu$Companion() {
    ContextMenu$Companion_instance = this;
    this.DEFAULT_FIXED_POS_X = 5;
    this.DEFAULT_FIXED_POS_Y = 5;
  }
  ContextMenu$Companion.$metadata$ = {kind: Kind_OBJECT, simpleName: 'Companion', interfaces: []};
  var ContextMenu$Companion_instance = null;
  function ContextMenu$Companion_getInstance() {
    if (ContextMenu$Companion_instance === null) {
      new ContextMenu$Companion();
    }return ContextMenu$Companion_instance;
  }
  ContextMenu.$metadata$ = {kind: Kind_CLASS, simpleName: 'ContextMenu', interfaces: [SimplePanel]};
  function Widget$refreshOnUpdate$lambda(this$Widget) {
    return function (it) {
      this$Widget.refresh();
      return Unit;
    };
  }
  function DD(name, ordinal, option) {
    Enum.call(this);
    this.option = option;
    this.name$ = name;
    this.ordinal$ = ordinal;
  }
  function DD_initFields() {
    DD_initFields = function () {
    };
    DD$HEADER_instance = new DD('HEADER', 0, 'DD#HEADER');
    DD$DISABLED_instance = new DD('DISABLED', 1, 'DD#DISABLED');
    DD$SEPARATOR_instance = new DD('SEPARATOR', 2, 'DD#SEPARATOR');
  }
  var DD$HEADER_instance;
  function DD$HEADER_getInstance() {
    DD_initFields();
    return DD$HEADER_instance;
  }
  var DD$DISABLED_instance;
  function DD$DISABLED_getInstance() {
    DD_initFields();
    return DD$DISABLED_instance;
  }
  var DD$SEPARATOR_instance;
  function DD$SEPARATOR_getInstance() {
    DD_initFields();
    return DD$SEPARATOR_instance;
  }
  DD.$metadata$ = {kind: Kind_CLASS, simpleName: 'DD', interfaces: [Enum]};
  function DD$values() {
    return [DD$HEADER_getInstance(), DD$DISABLED_getInstance(), DD$SEPARATOR_getInstance()];
  }
  DD.values = DD$values;
  function DD$valueOf(name) {
    switch (name) {
      case 'HEADER':
        return DD$HEADER_getInstance();
      case 'DISABLED':
        return DD$DISABLED_getInstance();
      case 'SEPARATOR':
        return DD$SEPARATOR_getInstance();
      default:throwISE('No enum constant io.kvision.dropdown.DD.' + name);
    }
  }
  DD.valueOf_61zpoe$ = DD$valueOf;
  function Direction(name, ordinal, direction) {
    Enum.call(this);
    this.direction_8be2vx$ = direction;
    this.name$ = name;
    this.ordinal$ = ordinal;
  }
  function Direction_initFields() {
    Direction_initFields = function () {
    };
    Direction$DROPDOWN_instance = new Direction('DROPDOWN', 0, 'dropdown');
    Direction$DROPUP_instance = new Direction('DROPUP', 1, 'dropup');
    Direction$DROPSTART_instance = new Direction('DROPSTART', 2, 'dropstart');
    Direction$DROPEND_instance = new Direction('DROPEND', 3, 'dropend');
    Direction$DROPLEFT_instance = new Direction('DROPLEFT', 4, 'dropstart');
    Direction$DROPRIGHT_instance = new Direction('DROPRIGHT', 5, 'dropend');
  }
  var Direction$DROPDOWN_instance;
  function Direction$DROPDOWN_getInstance() {
    Direction_initFields();
    return Direction$DROPDOWN_instance;
  }
  var Direction$DROPUP_instance;
  function Direction$DROPUP_getInstance() {
    Direction_initFields();
    return Direction$DROPUP_instance;
  }
  var Direction$DROPSTART_instance;
  function Direction$DROPSTART_getInstance() {
    Direction_initFields();
    return Direction$DROPSTART_instance;
  }
  var Direction$DROPEND_instance;
  function Direction$DROPEND_getInstance() {
    Direction_initFields();
    return Direction$DROPEND_instance;
  }
  var Direction$DROPLEFT_instance;
  function Direction$DROPLEFT_getInstance() {
    Direction_initFields();
    return Direction$DROPLEFT_instance;
  }
  var Direction$DROPRIGHT_instance;
  function Direction$DROPRIGHT_getInstance() {
    Direction_initFields();
    return Direction$DROPRIGHT_instance;
  }
  Direction.$metadata$ = {kind: Kind_CLASS, simpleName: 'Direction', interfaces: [Enum]};
  function Direction$values() {
    return [Direction$DROPDOWN_getInstance(), Direction$DROPUP_getInstance(), Direction$DROPSTART_getInstance(), Direction$DROPEND_getInstance(), Direction$DROPLEFT_getInstance(), Direction$DROPRIGHT_getInstance()];
  }
  Direction.values = Direction$values;
  function Direction$valueOf(name) {
    switch (name) {
      case 'DROPDOWN':
        return Direction$DROPDOWN_getInstance();
      case 'DROPUP':
        return Direction$DROPUP_getInstance();
      case 'DROPSTART':
        return Direction$DROPSTART_getInstance();
      case 'DROPEND':
        return Direction$DROPEND_getInstance();
      case 'DROPLEFT':
        return Direction$DROPLEFT_getInstance();
      case 'DROPRIGHT':
        return Direction$DROPRIGHT_getInstance();
      default:throwISE('No enum constant io.kvision.dropdown.Direction.' + name);
    }
  }
  Direction.valueOf_61zpoe$ = Direction$valueOf;
  function AutoClose(name, ordinal, attributeValue) {
    Enum.call(this);
    this.attributeValue_vx0zra$_0 = attributeValue;
    this.name$ = name;
    this.ordinal$ = ordinal;
  }
  function AutoClose_initFields() {
    AutoClose_initFields = function () {
    };
    AutoClose$TRUE_instance = new AutoClose('TRUE', 0, 'true');
    AutoClose$OUTSIDE_instance = new AutoClose('OUTSIDE', 1, 'outside');
    AutoClose$INSIDE_instance = new AutoClose('INSIDE', 2, 'inside');
    AutoClose$FALSE_instance = new AutoClose('FALSE', 3, 'false');
  }
  Object.defineProperty(AutoClose.prototype, 'attributeValue', {get: function () {
    return this.attributeValue_vx0zra$_0;
  }});
  var AutoClose$TRUE_instance;
  function AutoClose$TRUE_getInstance() {
    AutoClose_initFields();
    return AutoClose$TRUE_instance;
  }
  var AutoClose$OUTSIDE_instance;
  function AutoClose$OUTSIDE_getInstance() {
    AutoClose_initFields();
    return AutoClose$OUTSIDE_instance;
  }
  var AutoClose$INSIDE_instance;
  function AutoClose$INSIDE_getInstance() {
    AutoClose_initFields();
    return AutoClose$INSIDE_instance;
  }
  var AutoClose$FALSE_instance;
  function AutoClose$FALSE_getInstance() {
    AutoClose_initFields();
    return AutoClose$FALSE_instance;
  }
  Object.defineProperty(AutoClose.prototype, 'attributeName', {configurable: true, get: function () {
    return 'data-bs-auto-close';
  }});
  AutoClose.$metadata$ = {kind: Kind_CLASS, simpleName: 'AutoClose', interfaces: [DomAttribute, Enum]};
  function AutoClose$values() {
    return [AutoClose$TRUE_getInstance(), AutoClose$OUTSIDE_getInstance(), AutoClose$INSIDE_getInstance(), AutoClose$FALSE_getInstance()];
  }
  AutoClose.values = AutoClose$values;
  function AutoClose$valueOf(name) {
    switch (name) {
      case 'TRUE':
        return AutoClose$TRUE_getInstance();
      case 'OUTSIDE':
        return AutoClose$OUTSIDE_getInstance();
      case 'INSIDE':
        return AutoClose$INSIDE_getInstance();
      case 'FALSE':
        return AutoClose$FALSE_getInstance();
      default:throwISE('No enum constant io.kvision.dropdown.AutoClose.' + name);
    }
  }
  AutoClose.valueOf_61zpoe$ = AutoClose$valueOf;
  function DropDown(text, elements, icon, style, direction, disabled, forNavbar, forDropDown, dark, rightAligned, className, init) {
    DropDown$Companion_getInstance();
    if (elements === void 0)
      elements = null;
    if (icon === void 0)
      icon = null;
    if (style === void 0)
      style = ButtonStyle.PRIMARY;
    if (direction === void 0)
      direction = Direction$DROPDOWN_getInstance();
    if (disabled === void 0)
      disabled = false;
    if (forNavbar === void 0)
      forNavbar = false;
    if (forDropDown === void 0)
      forDropDown = false;
    if (dark === void 0)
      dark = false;
    if (rightAligned === void 0)
      rightAligned = false;
    if (className === void 0)
      className = null;
    if (init === void 0)
      init = null;
    SimplePanel.call(this, className);
    this.forNavbar = forNavbar;
    this.forDropDown = forDropDown;
    this.elements_o1tnq8$_phv4y$_0 = (new Widget$Widget$RefreshDelegateProvider_init(this, elements, DropDown$elements$lambda(this))).provideDelegate_n5byny$(this, DropDown$elements_metadata);
    this.direction_tyf9oe$_0 = (new Widget$Widget$RefreshDelegateProvider_init(this, direction, Widget$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, DropDown$direction_metadata);
    this.idc_m8ncvp$_0 = 'kv_dropdown_' + DropDown$Companion_getInstance().counter_8be2vx$;
    this.button = new DropDownButton(this.idc_m8ncvp$_0, text, icon, style, disabled, this.forNavbar, this.forDropDown);
    this.menu = new DropDownMenu(this.idc_m8ncvp$_0, dark, rightAligned);
    var tmp$;
    if (this.forDropDown) {
      this.style = ButtonStyle.LIGHT;
      this.direction = Direction$DROPEND_getInstance();
    }this.setChildrenFromElements_x4zszf$_0();
    this.addPrivate_87eobz$(this.button);
    this.addPrivate_87eobz$(this.menu);
    tmp$ = DropDown$Companion_getInstance().counter_8be2vx$;
    DropDown$Companion_getInstance().counter_8be2vx$ = tmp$ + 1 | 0;
    init != null ? init(this) : null;
  }
  Object.defineProperty(DropDown.prototype, 'text', {configurable: true, get: function () {
    return this.button.text;
  }, set: function (value) {
    this.button.text = value;
  }});
  var DropDown$elements_metadata = new PropertyMetadata('elements');
  Object.defineProperty(DropDown.prototype, 'elements_o1tnq8$_0', {configurable: true, get: function () {
    return this.elements_o1tnq8$_phv4y$_0.getValue_fmbzy8$(this, DropDown$elements_metadata);
  }, set: function (elements) {
    this.elements_o1tnq8$_phv4y$_0.setValue_19qrsr$(this, DropDown$elements_metadata, elements);
  }});
  Object.defineProperty(DropDown.prototype, 'icon', {configurable: true, get: function () {
    return this.button.icon;
  }, set: function (value) {
    this.button.icon = value;
  }});
  Object.defineProperty(DropDown.prototype, 'style', {configurable: true, get: function () {
    return this.button.style;
  }, set: function (value) {
    this.button.style = value;
  }});
  Object.defineProperty(DropDown.prototype, 'size', {configurable: true, get: function () {
    return this.button.size;
  }, set: function (value) {
    this.button.size = value;
  }});
  Object.defineProperty(DropDown.prototype, 'block', {configurable: true, get: function () {
    return this.button.block;
  }, set: function (value) {
    this.button.block = value;
  }});
  Object.defineProperty(DropDown.prototype, 'disabled', {configurable: true, get: function () {
    return this.button.disabled;
  }, set: function (value) {
    this.button.disabled = value;
  }});
  Object.defineProperty(DropDown.prototype, 'image', {configurable: true, get: function () {
    return this.button.image;
  }, set: function (value) {
    this.button.image = value;
  }});
  Object.defineProperty(DropDown.prototype, 'dark', {configurable: true, get: function () {
    return this.menu.dark;
  }, set: function (value) {
    this.menu.dark = value;
  }});
  Object.defineProperty(DropDown.prototype, 'rightAligned', {configurable: true, get: function () {
    return this.menu.rightAligned;
  }, set: function (value) {
    this.menu.rightAligned = value;
  }});
  var DropDown$direction_metadata = new PropertyMetadata('direction');
  Object.defineProperty(DropDown.prototype, 'direction', {configurable: true, get: function () {
    return this.direction_tyf9oe$_0.getValue_fmbzy8$(this, DropDown$direction_metadata);
  }, set: function (direction) {
    this.direction_tyf9oe$_0.setValue_19qrsr$(this, DropDown$direction_metadata, direction);
  }});
  Object.defineProperty(DropDown.prototype, 'autoClose', {configurable: true, get: function () {
    return this.button.autoClose;
  }, set: function (value) {
    this.button.autoClose = value;
  }});
  Object.defineProperty(DropDown.prototype, 'width', {configurable: true, get: function () {
    return Kotlin.callGetter(this, SimplePanel.prototype, 'width');
  }, set: function (value) {
    Kotlin.callSetter(this, SimplePanel.prototype, 'width', value);
    this.button.width = value;
  }});
  DropDown.prototype.buttonId = function () {
    return this.button.id;
  };
  DropDown.prototype.add_87eobz$ = function (child) {
    this.menu.add_87eobz$(child);
    return this;
  };
  DropDown.prototype.add_pqktxj$ = function (position, child) {
    this.menu.add_pqktxj$(position, child);
    return this;
  };
  DropDown.prototype.addAll_xquxs0$ = function (children) {
    this.menu.addAll_xquxs0$(children);
    return this;
  };
  DropDown.prototype.remove_87eobz$ = function (child) {
    this.menu.remove_87eobz$(child);
    return this;
  };
  DropDown.prototype.removeAt_za3lpa$ = function (position) {
    this.menu.removeAt_za3lpa$(position);
    return this;
  };
  DropDown.prototype.removeAll = function () {
    this.menu.removeAll();
    return this;
  };
  DropDown.prototype.disposeAll = function () {
    this.menu.disposeAll();
    return this;
  };
  DropDown.prototype.getChildren = function () {
    return this.menu.getChildren();
  };
  DropDown.prototype.setChildrenFromElements_x4zszf$_0 = function () {
    var tmp$;
    this.menu.removeAll();
    if ((tmp$ = this.elements_o1tnq8$_0) != null) {
      var destination = ArrayList_init(collectionSizeOrDefault(tmp$, 10));
      var tmp$_0;
      tmp$_0 = tmp$.iterator();
      while (tmp$_0.hasNext()) {
        var item = tmp$_0.next();
        var tmp$_1 = destination.add_11rb$;
        var transform$result;
        var tmp$_2;
        tmp$_2 = item.second;
        if (equals(tmp$_2, DD$HEADER_getInstance().option)) {
          transform$result = new Header(item.first);
        } else if (equals(tmp$_2, DD$SEPARATOR_getInstance().option)) {
          transform$result = new Separator();
        } else if (equals(tmp$_2, DD$DISABLED_getInstance().option)) {
          var $receiver = new Link(item.first, 'javascript:void(0)', void 0, void 0, void 0, void 0, void 0, void 0, 'dropdown-item disabled');
          $receiver.tabindex = -1;
          $receiver.setAttribute_puj7f4$('aria-disabled', 'true');
          transform$result = $receiver;
        } else {
          transform$result = new Link(item.first, item.second, void 0, void 0, void 0, void 0, void 0, void 0, 'dropdown-item');
        }
        tmp$_1.call(destination, transform$result);
      }
      var c = destination;
      this.menu.addAll_xquxs0$(c);
    }};
  DropDown.prototype.buildClassSet_xutoed$ = function (classSetBuilder) {
    SimplePanel.prototype.buildClassSet_xutoed$.call(this, classSetBuilder);
    if (this.forNavbar)
      classSetBuilder.add_61zpoe$('nav-item');
    classSetBuilder.add_61zpoe$(this.direction.direction_8be2vx$);
  };
  DropDown.prototype.toggle = function () {
    var tmp$ = this.button;
    var tmp$_0;
    var $receiver = (tmp$_0 = {}) == null || Kotlin.isType(tmp$_0, Object_init) ? tmp$_0 : throwCCE();
    $receiver.bubbles = true;
    tmp$.dispatchEvent_nxedta$('click', $receiver);
  };
  function DropDown$Companion() {
    DropDown$Companion_instance = this;
    this.counter_8be2vx$ = 0;
  }
  DropDown$Companion.$metadata$ = {kind: Kind_OBJECT, simpleName: 'Companion', interfaces: []};
  var DropDown$Companion_instance = null;
  function DropDown$Companion_getInstance() {
    if (DropDown$Companion_instance === null) {
      new DropDown$Companion();
    }return DropDown$Companion_instance;
  }
  function DropDown$elements$lambda(this$DropDown) {
    return function (it) {
      this$DropDown.setChildrenFromElements_x4zszf$_0();
      return Unit;
    };
  }
  DropDown.$metadata$ = {kind: Kind_CLASS, simpleName: 'DropDown', interfaces: [SimplePanel]};
  function dropDown($receiver, text, elements, icon, style, direction, disabled, forNavbar, forDropDown, dark, rightAligned, className, init) {
    if (elements === void 0)
      elements = null;
    if (icon === void 0)
      icon = null;
    if (style === void 0)
      style = ButtonStyle.PRIMARY;
    if (direction === void 0)
      direction = Direction$DROPDOWN_getInstance();
    if (disabled === void 0)
      disabled = false;
    if (forNavbar === void 0)
      forNavbar = false;
    if (forDropDown === void 0)
      forDropDown = false;
    if (dark === void 0)
      dark = false;
    if (rightAligned === void 0)
      rightAligned = false;
    if (className === void 0)
      className = null;
    if (init === void 0)
      init = null;
    var dropDown = new DropDown(text, elements, icon, style, direction, disabled, forNavbar, forDropDown, dark, rightAligned, className, init);
    $receiver.add_87eobz$(dropDown);
    return dropDown;
  }
  function ddLink($receiver, label, url, icon, image, dataNavigo, className, init) {
    if (url === void 0)
      url = null;
    if (icon === void 0)
      icon = null;
    if (image === void 0)
      image = null;
    if (dataNavigo === void 0)
      dataNavigo = null;
    if (className === void 0)
      className = null;
    if (init === void 0)
      init = null;
    var tmp$;
    var link = new Link(label, url, icon, image, null, true, null, dataNavigo, ((tmp$ = className != null ? className + ' ' : null) != null ? tmp$ : '') + 'dropdown-item', init);
    $receiver.add_87eobz$(link);
    return link;
  }
  function Widget$refreshOnUpdate$lambda_0(this$Widget) {
    return function (it) {
      this$Widget.refresh();
      return Unit;
    };
  }
  function DropDownButton(id, text, icon, style, disabled, forNavbar, forDropDown, autoClose, className) {
    if (icon === void 0)
      icon = null;
    if (style === void 0)
      style = ButtonStyle.PRIMARY;
    if (disabled === void 0)
      disabled = false;
    if (forNavbar === void 0)
      forNavbar = false;
    if (forDropDown === void 0)
      forDropDown = false;
    if (autoClose === void 0)
      autoClose = AutoClose$TRUE_getInstance();
    if (className === void 0)
      className = null;
    Button.call(this, text, icon, style, ButtonType.BUTTON, disabled, null, true, className);
    this.forNavbar = forNavbar;
    this.forDropDown = forDropDown;
    this.autoClose_uo1e8u$_0 = (new Widget$Widget$RefreshDelegateProvider_init(this, autoClose, Widget$refreshOnUpdate$lambda_0(this))).provideDelegate_n5byny$(this, DropDownButton$autoClose_metadata);
    this.id = id;
    if (!this.forNavbar && !this.forDropDown)
      this.role = 'button';
    this.setInternalEventListener_a1up2z$(DropDownButton_init$lambda(this));
  }
  var DropDownButton$autoClose_metadata = new PropertyMetadata('autoClose');
  Object.defineProperty(DropDownButton.prototype, 'autoClose', {configurable: true, get: function () {
    return this.autoClose_uo1e8u$_0.getValue_fmbzy8$(this, DropDownButton$autoClose_metadata);
  }, set: function (autoClose) {
    this.autoClose_uo1e8u$_0.setValue_19qrsr$(this, DropDownButton$autoClose_metadata, autoClose);
  }});
  DropDownButton.prototype.render = function () {
    var tmp$;
    var text = this.createLabelWithIcon_dawjdb$(this.text, this.icon, this.image);
    if (this.forNavbar || this.forDropDown) {
      tmp$ = this.render_pjwf99$('a', text);
    } else {
      tmp$ = this.render_pjwf99$('button', text);
    }
    return tmp$;
  };
  function DropDownButton$buildClassSet$lambda$ObjectLiteral(closure$classSetBuilder) {
    this.closure$classSetBuilder = closure$classSetBuilder;
  }
  DropDownButton$buildClassSet$lambda$ObjectLiteral.prototype.add_61zpoe$ = function (value) {
    if (!equals(value, 'btn') && !equals(value, 'btn-primary'))
      this.closure$classSetBuilder.add_61zpoe$(value);
  };
  DropDownButton$buildClassSet$lambda$ObjectLiteral.prototype.addAll_jfy1ql$ = function (values) {
    this.closure$classSetBuilder.addAll_jfy1ql$(values);
  };
  DropDownButton$buildClassSet$lambda$ObjectLiteral.$metadata$ = {kind: Kind_CLASS, interfaces: [ClassSetBuilder]};
  DropDownButton.prototype.buildClassSet_xutoed$ = function (classSetBuilder) {
    classSetBuilder.add_61zpoe$('dropdown-toggle');
    if (this.forNavbar) {
      Button.prototype.buildClassSet_xutoed$.call(this, new DropDownButton$buildClassSet$lambda$ObjectLiteral(classSetBuilder));
      classSetBuilder.add_61zpoe$('nav-link');
    } else if (this.forDropDown) {
      Button.prototype.buildClassSet_xutoed$.call(this, classSetBuilder);
      classSetBuilder.add_61zpoe$('dropdown-item');
    } else
      Button.prototype.buildClassSet_xutoed$.call(this, classSetBuilder);
  };
  function DropDownButton$buildAttributeSet$ObjectLiteral(closure$attributeSetBuilder) {
    this.closure$attributeSetBuilder = closure$attributeSetBuilder;
  }
  DropDownButton$buildAttributeSet$ObjectLiteral.prototype.add_puj7f4$$default = function (name, value) {
    if (!equals(name, 'type'))
      this.closure$attributeSetBuilder.add_puj7f4$(name, value);
  };
  DropDownButton$buildAttributeSet$ObjectLiteral.$metadata$ = {kind: Kind_CLASS, interfaces: [AttributeSetBuilder]};
  DropDownButton.prototype.buildAttributeSet_34lhpl$ = function (attributeSetBuilder) {
    var tmp$;
    if (this.forDropDown || this.forNavbar) {
      tmp$ = new DropDownButton$buildAttributeSet$ObjectLiteral(attributeSetBuilder);
    } else {
      tmp$ = attributeSetBuilder;
    }
    Button.prototype.buildAttributeSet_34lhpl$.call(this, tmp$);
    attributeSetBuilder.add_puj7f4$('data-bs-toggle', 'dropdown');
    attributeSetBuilder.add_puj7f4$('aria-haspopup', 'true');
    attributeSetBuilder.add_puj7f4$('aria-expanded', 'false');
    attributeSetBuilder.add_puj7f4$('href', 'javascript:void(0)');
    attributeSetBuilder.add_lcqont$(this.autoClose);
  };
  function DropDownButton_init$lambda$lambda(this$DropDownButton) {
    return function (e) {
      var tmp$;
      if (Kotlin.isType((tmp$ = this$DropDownButton.parent) != null ? tmp$.parent : null, ContextMenu)) {
        e.dropDownCM = true;
      } else if (this$DropDownButton.forDropDown) {
        e.stopPropagation();
      }return Unit;
    };
  }
  function DropDownButton_init$lambda(this$DropDownButton) {
    return function ($receiver) {
      $receiver.click = DropDownButton_init$lambda$lambda(this$DropDownButton);
      return Unit;
    };
  }
  DropDownButton.$metadata$ = {kind: Kind_CLASS, simpleName: 'DropDownButton', interfaces: [Button]};
  function Widget$refreshOnUpdate$lambda_1(this$Widget) {
    return function (it) {
      this$Widget.refresh();
      return Unit;
    };
  }
  function DropDownMenu(ariaId, dark, rightAligned) {
    if (dark === void 0)
      dark = false;
    if (rightAligned === void 0)
      rightAligned = false;
    SimplePanel.call(this, 'dropdown-menu');
    this.ariaId_oy4zua$_0 = ariaId;
    this.dark_481kg0$_0 = (new Widget$Widget$RefreshDelegateProvider_init(this, dark, Widget$refreshOnUpdate$lambda_1(this))).provideDelegate_n5byny$(this, DropDownMenu$dark_metadata);
    this.rightAligned_7g8z0u$_0 = (new Widget$Widget$RefreshDelegateProvider_init(this, rightAligned, Widget$refreshOnUpdate$lambda_1(this))).provideDelegate_n5byny$(this, DropDownMenu$rightAligned_metadata);
  }
  var DropDownMenu$dark_metadata = new PropertyMetadata('dark');
  Object.defineProperty(DropDownMenu.prototype, 'dark', {configurable: true, get: function () {
    return this.dark_481kg0$_0.getValue_fmbzy8$(this, DropDownMenu$dark_metadata);
  }, set: function (dark) {
    this.dark_481kg0$_0.setValue_19qrsr$(this, DropDownMenu$dark_metadata, dark);
  }});
  var DropDownMenu$rightAligned_metadata = new PropertyMetadata('rightAligned');
  Object.defineProperty(DropDownMenu.prototype, 'rightAligned', {configurable: true, get: function () {
    return this.rightAligned_7g8z0u$_0.getValue_fmbzy8$(this, DropDownMenu$rightAligned_metadata);
  }, set: function (rightAligned) {
    this.rightAligned_7g8z0u$_0.setValue_19qrsr$(this, DropDownMenu$rightAligned_metadata, rightAligned);
  }});
  DropDownMenu.prototype.buildAttributeSet_34lhpl$ = function (attributeSetBuilder) {
    SimplePanel.prototype.buildAttributeSet_34lhpl$.call(this, attributeSetBuilder);
    attributeSetBuilder.add_puj7f4$('aria-labelledby', this.ariaId_oy4zua$_0);
  };
  DropDownMenu.prototype.buildClassSet_xutoed$ = function (classSetBuilder) {
    SimplePanel.prototype.buildClassSet_xutoed$.call(this, classSetBuilder);
    if (this.dark)
      classSetBuilder.add_61zpoe$('dropdown-menu-dark');
    if (this.rightAligned)
      classSetBuilder.add_61zpoe$('dropdown-menu-end');
  };
  DropDownMenu.$metadata$ = {kind: Kind_CLASS, simpleName: 'DropDownMenu', interfaces: [SimplePanel]};
  function Header(content, className) {
    if (content === void 0)
      content = null;
    if (className === void 0)
      className = null;
    var tmp$;
    Tag.call(this, TAG.H6, content, void 0, void 0, ((tmp$ = className != null ? className + ' ' : null) != null ? tmp$ : '') + 'dropdown-header');
  }
  Header.$metadata$ = {kind: Kind_CLASS, simpleName: 'Header', interfaces: [Tag]};
  function Separator(className) {
    if (className === void 0)
      className = null;
    var tmp$;
    SimplePanel.call(this, ((tmp$ = className != null ? className + ' ' : null) != null ? tmp$ : '') + 'dropdown-divider');
  }
  Separator.$metadata$ = {kind: Kind_CLASS, simpleName: 'Separator', interfaces: [SimplePanel]};
  function separator_0($receiver, className) {
    if (className === void 0)
      className = null;
    var separator = new Separator(className);
    $receiver.add_87eobz$(separator);
    return separator;
  }
  function Alert(caption, text, rich, align, size, animation, centered, callback) {
    Alert$Companion_getInstance();
    if (caption === void 0)
      caption = null;
    if (text === void 0)
      text = null;
    if (rich === void 0)
      rich = false;
    if (align === void 0)
      align = null;
    if (size === void 0)
      size = null;
    if (animation === void 0)
      animation = true;
    if (centered === void 0)
      centered = false;
    if (callback === void 0)
      callback = null;
    Modal.call(this, caption, true, size, animation, centered);
    this.callback_8khm7z$_0 = callback;
    this.contentTag_t1ik6b$_0 = new Tag(TAG.DIV, text, rich, align);
    this.body.add_87eobz$(this.contentTag_t1ik6b$_0);
    var okButton = new Button('OK', 'fas fa-check', ButtonStyle.PRIMARY);
    okButton.setEventListener_a1up2z$(Alert_init$lambda(this));
    this.addButton_cjs2a$(okButton);
    this.setEventListener_a1up2z$(Alert_init$lambda_0(this, okButton));
  }
  Object.defineProperty(Alert.prototype, 'text', {configurable: true, get: function () {
    return this.contentTag_t1ik6b$_0.content;
  }, set: function (value) {
    this.contentTag_t1ik6b$_0.content = value;
  }});
  Object.defineProperty(Alert.prototype, 'rich', {configurable: true, get: function () {
    return this.contentTag_t1ik6b$_0.rich;
  }, set: function (value) {
    this.contentTag_t1ik6b$_0.rich = value;
  }});
  Object.defineProperty(Alert.prototype, 'align', {configurable: true, get: function () {
    return this.contentTag_t1ik6b$_0.align;
  }, set: function (value) {
    this.contentTag_t1ik6b$_0.align = value;
  }});
  Alert.prototype.hide = function () {
    var tmp$;
    Modal.prototype.hide.call(this);
    (tmp$ = this.callback_8khm7z$_0) != null ? tmp$() : null;
    return this;
  };
  function Alert$Companion() {
    Alert$Companion_instance = this;
  }
  Alert$Companion.prototype.show_503xog$ = function (caption, text, rich, align, size, animation, centered, callback) {
    if (caption === void 0)
      caption = null;
    if (text === void 0)
      text = null;
    if (rich === void 0)
      rich = false;
    if (align === void 0)
      align = null;
    if (size === void 0)
      size = null;
    if (animation === void 0)
      animation = true;
    if (centered === void 0)
      centered = false;
    if (callback === void 0)
      callback = null;
    (new Alert(caption, text, rich, align, size, animation, centered, callback)).show();
  };
  Alert$Companion.$metadata$ = {kind: Kind_OBJECT, simpleName: 'Companion', interfaces: []};
  var Alert$Companion_instance = null;
  function Alert$Companion_getInstance() {
    if (Alert$Companion_instance === null) {
      new Alert$Companion();
    }return Alert$Companion_instance;
  }
  function Alert_init$lambda$lambda(this$Alert) {
    return function (it) {
      this$Alert.hide();
      return Unit;
    };
  }
  function Alert_init$lambda(this$Alert) {
    return function ($receiver) {
      $receiver.click = Alert_init$lambda$lambda(this$Alert);
      return Unit;
    };
  }
  function Alert_init$lambda$lambda_0(this$Alert) {
    return function (e) {
      if (e.keyCode === 13) {
        this$Alert.hide();
      }return Unit;
    };
  }
  function Alert_init$lambda$lambda_1(closure$okButton) {
    return function (it) {
      closure$okButton.focus();
      return Unit;
    };
  }
  function Alert_init$lambda_0(this$Alert, closure$okButton) {
    return function ($receiver) {
      $receiver.keydown = Alert_init$lambda$lambda_0(this$Alert);
      set($receiver, 'shown.bs.modal', Alert_init$lambda$lambda_1(closure$okButton));
      return Unit;
    };
  }
  Alert.$metadata$ = {kind: Kind_CLASS, simpleName: 'Alert', interfaces: [Modal]};
  function CloseIcon() {
    Widget.call(this);
  }
  CloseIcon.prototype.render = function () {
    return this.render_61zpoe$('button');
  };
  CloseIcon.prototype.buildClassSet_xutoed$ = function (classSetBuilder) {
    Widget.prototype.buildClassSet_xutoed$.call(this, classSetBuilder);
    classSetBuilder.add_61zpoe$('btn-close');
  };
  CloseIcon.prototype.buildAttributeSet_34lhpl$ = function (attributeSetBuilder) {
    Widget.prototype.buildAttributeSet_34lhpl$.call(this, attributeSetBuilder);
    attributeSetBuilder.add_puj7f4$('type', 'button');
    attributeSetBuilder.add_puj7f4$('aria-label', 'Close');
  };
  CloseIcon.$metadata$ = {kind: Kind_CLASS, simpleName: 'CloseIcon', interfaces: [Widget]};
  function Confirm(caption, text, rich, align, size, animation, centered, cancelVisible, yesTitle, noTitle, cancelTitle, noCallback, yesCallback) {
    Confirm$Companion_getInstance();
    if (caption === void 0)
      caption = null;
    if (text === void 0)
      text = null;
    if (rich === void 0)
      rich = false;
    if (align === void 0)
      align = null;
    if (size === void 0)
      size = null;
    if (animation === void 0)
      animation = true;
    if (centered === void 0)
      centered = false;
    if (cancelVisible === void 0)
      cancelVisible = false;
    if (yesTitle === void 0)
      yesTitle = 'Yes';
    if (noTitle === void 0)
      noTitle = 'No';
    if (cancelTitle === void 0)
      cancelTitle = 'Cancel';
    if (noCallback === void 0)
      noCallback = null;
    if (yesCallback === void 0)
      yesCallback = null;
    Modal.call(this, caption, false, size, animation, centered, false, cancelVisible);
    this.noCallback_pj4sf6$_0 = noCallback;
    this.yesCallback_m2wfkw$_0 = yesCallback;
    this.cancelVisible_3avys4$_0 = (new Widget$Widget$RefreshDelegateProvider_init(this, cancelVisible, Confirm$cancelVisible$lambda(this))).provideDelegate_n5byny$(this, Confirm$cancelVisible_metadata);
    this.contentTag_aeedxj$_0 = new Tag(TAG.DIV, text, rich, align);
    this.cancelButton_a4kge4$_0 = new Button(cancelTitle, 'fas fa-times');
    this.noButton_qmyx4b$_0 = new Button(noTitle, 'fas fa-ban');
    this.yesButton_ulfmhf$_0 = new Button(yesTitle, 'fas fa-check', ButtonStyle.PRIMARY);
    this.body.add_87eobz$(this.contentTag_aeedxj$_0);
    this.cancelButton_a4kge4$_0.setEventListener_a1up2z$(Confirm_init$lambda(this));
    this.addButton_cjs2a$(this.cancelButton_a4kge4$_0);
    this.noButton_qmyx4b$_0.setEventListener_a1up2z$(Confirm_init$lambda_0(this));
    this.addButton_cjs2a$(this.noButton_qmyx4b$_0);
    this.yesButton_ulfmhf$_0.setEventListener_a1up2z$(Confirm_init$lambda_1(this));
    this.addButton_cjs2a$(this.yesButton_ulfmhf$_0);
    this.refreshCancelButton_b4gzjv$_0();
    this.setEventListener_a1up2z$(Confirm_init$lambda_2(this));
  }
  Object.defineProperty(Confirm.prototype, 'text', {configurable: true, get: function () {
    return this.contentTag_aeedxj$_0.content;
  }, set: function (value) {
    this.contentTag_aeedxj$_0.content = value;
  }});
  Object.defineProperty(Confirm.prototype, 'rich', {configurable: true, get: function () {
    return this.contentTag_aeedxj$_0.rich;
  }, set: function (value) {
    this.contentTag_aeedxj$_0.rich = value;
  }});
  Object.defineProperty(Confirm.prototype, 'align', {configurable: true, get: function () {
    return this.contentTag_aeedxj$_0.align;
  }, set: function (value) {
    this.contentTag_aeedxj$_0.align = value;
  }});
  var Confirm$cancelVisible_metadata = new PropertyMetadata('cancelVisible');
  Object.defineProperty(Confirm.prototype, 'cancelVisible', {configurable: true, get: function () {
    return this.cancelVisible_3avys4$_0.getValue_fmbzy8$(this, Confirm$cancelVisible_metadata);
  }, set: function (cancelVisible) {
    this.cancelVisible_3avys4$_0.setValue_19qrsr$(this, Confirm$cancelVisible_metadata, cancelVisible);
  }});
  Object.defineProperty(Confirm.prototype, 'yesTitle', {configurable: true, get: function () {
    return this.yesButton_ulfmhf$_0.text;
  }, set: function (value) {
    this.yesButton_ulfmhf$_0.text = value;
  }});
  Object.defineProperty(Confirm.prototype, 'noTitle', {configurable: true, get: function () {
    return this.noButton_qmyx4b$_0.text;
  }, set: function (value) {
    this.noButton_qmyx4b$_0.text = value;
  }});
  Object.defineProperty(Confirm.prototype, 'cancelTitle', {configurable: true, get: function () {
    return this.cancelButton_a4kge4$_0.text;
  }, set: function (value) {
    this.cancelButton_a4kge4$_0.text = value;
  }});
  Confirm.prototype.refreshCancelButton_b4gzjv$_0 = function () {
    if (this.cancelVisible) {
      this.cancelButton_a4kge4$_0.show();
      this.closeIcon.show();
    } else {
      this.cancelButton_a4kge4$_0.hide();
      this.closeIcon.hide();
    }
  };
  function Confirm$Companion() {
    Confirm$Companion_instance = this;
  }
  Confirm$Companion.prototype.show_d19t5t$ = function (caption, text, rich, align, size, animation, centered, cancelVisible, yesTitle, noTitle, cancelTitle, noCallback, yesCallback) {
    if (caption === void 0)
      caption = null;
    if (text === void 0)
      text = null;
    if (rich === void 0)
      rich = false;
    if (align === void 0)
      align = null;
    if (size === void 0)
      size = null;
    if (animation === void 0)
      animation = true;
    if (centered === void 0)
      centered = false;
    if (cancelVisible === void 0)
      cancelVisible = false;
    if (yesTitle === void 0)
      yesTitle = 'Yes';
    if (noTitle === void 0)
      noTitle = 'No';
    if (cancelTitle === void 0)
      cancelTitle = 'Cancel';
    if (noCallback === void 0)
      noCallback = null;
    if (yesCallback === void 0)
      yesCallback = null;
    (new Confirm(caption, text, rich, align, size, animation, centered, cancelVisible, yesTitle, noTitle, cancelTitle, noCallback, yesCallback)).show();
  };
  Confirm$Companion.$metadata$ = {kind: Kind_OBJECT, simpleName: 'Companion', interfaces: []};
  var Confirm$Companion_instance = null;
  function Confirm$Companion_getInstance() {
    if (Confirm$Companion_instance === null) {
      new Confirm$Companion();
    }return Confirm$Companion_instance;
  }
  function Confirm$cancelVisible$lambda(this$Confirm) {
    return function (it) {
      this$Confirm.refreshCancelButton_b4gzjv$_0();
      return Unit;
    };
  }
  function Confirm_init$lambda$lambda(this$Confirm) {
    return function (it) {
      this$Confirm.hide();
      return Unit;
    };
  }
  function Confirm_init$lambda(this$Confirm) {
    return function ($receiver) {
      $receiver.click = Confirm_init$lambda$lambda(this$Confirm);
      return Unit;
    };
  }
  function Confirm_init$lambda$lambda_0(this$Confirm) {
    return function (it) {
      var tmp$;
      this$Confirm.hide();
      (tmp$ = this$Confirm.noCallback_pj4sf6$_0) != null ? tmp$() : null;
      return Unit;
    };
  }
  function Confirm_init$lambda_0(this$Confirm) {
    return function ($receiver) {
      $receiver.click = Confirm_init$lambda$lambda_0(this$Confirm);
      return Unit;
    };
  }
  function Confirm_init$lambda$lambda_1(this$Confirm) {
    return function (it) {
      var tmp$;
      this$Confirm.hide();
      (tmp$ = this$Confirm.yesCallback_m2wfkw$_0) != null ? tmp$() : null;
      return Unit;
    };
  }
  function Confirm_init$lambda_1(this$Confirm) {
    return function ($receiver) {
      $receiver.click = Confirm_init$lambda$lambda_1(this$Confirm);
      return Unit;
    };
  }
  function Confirm_init$lambda$lambda_2(this$Confirm) {
    return function (it) {
      this$Confirm.yesButton_ulfmhf$_0.focus();
      return Unit;
    };
  }
  function Confirm_init$lambda_2(this$Confirm) {
    return function ($receiver) {
      set($receiver, 'shown.bs.modal', Confirm_init$lambda$lambda_2(this$Confirm));
      return Unit;
    };
  }
  Confirm.$metadata$ = {kind: Kind_CLASS, simpleName: 'Confirm', interfaces: [Modal]};
  function Widget$refreshOnUpdate$lambda_3(this$Widget) {
    return function (it) {
      this$Widget.refresh();
      return Unit;
    };
  }
  function ModalSize(name, ordinal, className) {
    Enum.call(this);
    this.className_6zrkpx$_0 = className;
    this.name$ = name;
    this.ordinal$ = ordinal;
  }
  function ModalSize_initFields() {
    ModalSize_initFields = function () {
    };
    ModalSize$XLARGE_instance = new ModalSize('XLARGE', 0, 'modal-xl');
    ModalSize$LARGE_instance = new ModalSize('LARGE', 1, 'modal-lg');
    ModalSize$SMALL_instance = new ModalSize('SMALL', 2, 'modal-sm');
  }
  Object.defineProperty(ModalSize.prototype, 'className', {get: function () {
    return this.className_6zrkpx$_0;
  }});
  var ModalSize$XLARGE_instance;
  function ModalSize$XLARGE_getInstance() {
    ModalSize_initFields();
    return ModalSize$XLARGE_instance;
  }
  var ModalSize$LARGE_instance;
  function ModalSize$LARGE_getInstance() {
    ModalSize_initFields();
    return ModalSize$LARGE_instance;
  }
  var ModalSize$SMALL_instance;
  function ModalSize$SMALL_getInstance() {
    ModalSize_initFields();
    return ModalSize$SMALL_instance;
  }
  ModalSize.$metadata$ = {kind: Kind_CLASS, simpleName: 'ModalSize', interfaces: [CssClass, Enum]};
  function ModalSize$values() {
    return [ModalSize$XLARGE_getInstance(), ModalSize$LARGE_getInstance(), ModalSize$SMALL_getInstance()];
  }
  ModalSize.values = ModalSize$values;
  function ModalSize$valueOf(name) {
    switch (name) {
      case 'XLARGE':
        return ModalSize$XLARGE_getInstance();
      case 'LARGE':
        return ModalSize$LARGE_getInstance();
      case 'SMALL':
        return ModalSize$SMALL_getInstance();
      default:throwISE('No enum constant io.kvision.modal.ModalSize.' + name);
    }
  }
  ModalSize.valueOf_61zpoe$ = ModalSize$valueOf;
  function Modal(caption, closeButton, size, animation, centered, scrollable, escape, className, init) {
    if (caption === void 0)
      caption = null;
    if (closeButton === void 0)
      closeButton = true;
    if (size === void 0)
      size = null;
    if (animation === void 0)
      animation = true;
    if (centered === void 0)
      centered = false;
    if (scrollable === void 0)
      scrollable = false;
    if (escape === void 0)
      escape = true;
    if (className === void 0)
      className = null;
    if (init === void 0)
      init = null;
    SimplePanel.call(this, className);
    this.escape_uup4gk$_0 = escape;
    this.parent_t2rodx$_0 = Root.Companion.getFirstRoot();
    this.animation_vygd7$_0 = (new Widget$Widget$RefreshDelegateProvider_init(this, animation, Widget$refreshOnUpdate$lambda_3(this))).provideDelegate_n5byny$(this, Modal$animation_metadata);
    this.dialog_bey19p$_0 = new ModalDialog(size, centered, scrollable);
    this.header = new SimplePanel('modal-header');
    this.closeIcon = new CloseIcon();
    this.captionTag_o3hfvj$_0 = new Tag(TAG.H5, caption, void 0, void 0, 'modal-title');
    this.body = new SimplePanel('modal-body');
    this.footer = new SimplePanel('modal-footer');
    this.useSnabbdomDistinctKey();
    this.hide();
    this.role = 'dialog';
    this.tabindex = -1;
    this.addPrivate_87eobz$(this.dialog_bey19p$_0);
    var content = new SimplePanel('modal-content');
    this.dialog_bey19p$_0.role = 'document';
    this.dialog_bey19p$_0.add_87eobz$(content);
    this.closeIcon.visible = closeButton;
    this.closeIcon.setEventListener_a1up2z$(Modal_init$lambda(this));
    this.header.add_87eobz$(this.captionTag_o3hfvj$_0);
    this.header.add_87eobz$(this.closeIcon);
    this.checkHeaderVisibility_eo6mmw$_0();
    content.add_87eobz$(this.header);
    content.add_87eobz$(this.body);
    content.add_87eobz$(this.footer);
    Root.Companion.addModal_y7t574$(this);
    init != null ? init(this) : null;
  }
  Object.defineProperty(Modal.prototype, 'parent', {configurable: true, get: function () {
    return this.parent_t2rodx$_0;
  }, set: function (parent) {
    this.parent_t2rodx$_0 = parent;
  }});
  Object.defineProperty(Modal.prototype, 'caption', {configurable: true, get: function () {
    return this.captionTag_o3hfvj$_0.content;
  }, set: function (value) {
    this.captionTag_o3hfvj$_0.content = value;
    this.checkHeaderVisibility_eo6mmw$_0();
  }});
  Object.defineProperty(Modal.prototype, 'closeButton', {configurable: true, get: function () {
    return this.closeIcon.visible;
  }, set: function (value) {
    this.closeIcon.visible = value;
    this.checkHeaderVisibility_eo6mmw$_0();
  }});
  Object.defineProperty(Modal.prototype, 'size', {configurable: true, get: function () {
    return this.dialog_bey19p$_0.size;
  }, set: function (value) {
    this.dialog_bey19p$_0.size = value;
  }});
  var Modal$animation_metadata = new PropertyMetadata('animation');
  Object.defineProperty(Modal.prototype, 'animation', {configurable: true, get: function () {
    return this.animation_vygd7$_0.getValue_fmbzy8$(this, Modal$animation_metadata);
  }, set: function (animation) {
    this.animation_vygd7$_0.setValue_19qrsr$(this, Modal$animation_metadata, animation);
  }});
  Object.defineProperty(Modal.prototype, 'centered', {configurable: true, get: function () {
    return this.dialog_bey19p$_0.centered;
  }, set: function (value) {
    this.dialog_bey19p$_0.centered = value;
  }});
  Object.defineProperty(Modal.prototype, 'scrollable', {configurable: true, get: function () {
    return this.dialog_bey19p$_0.scrollable;
  }, set: function (value) {
    this.dialog_bey19p$_0.scrollable = value;
  }});
  Modal.prototype.checkHeaderVisibility_eo6mmw$_0 = function () {
    if (!this.closeButton && this.caption == null) {
      this.header.hide();
    } else {
      this.header.show();
    }
  };
  Modal.prototype.add_87eobz$ = function (child) {
    this.body.add_87eobz$(child);
    return this;
  };
  Modal.prototype.add_pqktxj$ = function (position, child) {
    this.body.add_pqktxj$(position, child);
    return this;
  };
  Modal.prototype.addAll_xquxs0$ = function (children) {
    this.body.addAll_xquxs0$(children);
    return this;
  };
  Modal.prototype.remove_87eobz$ = function (child) {
    this.body.remove_87eobz$(child);
    return this;
  };
  Modal.prototype.removeAt_za3lpa$ = function (position) {
    this.body.removeAt_za3lpa$(position);
    return this;
  };
  Modal.prototype.removeAll = function () {
    this.body.removeAll();
    return this;
  };
  Modal.prototype.disposeAll = function () {
    this.body.disposeAll();
    return this;
  };
  Modal.prototype.getChildren = function () {
    return this.body.getChildren();
  };
  Modal.prototype.addButton_cjs2a$ = function (button) {
    this.footer.add_87eobz$(button);
    return this;
  };
  Modal.prototype.removeButton_cjs2a$ = function (button) {
    this.footer.remove_87eobz$(button);
    return this;
  };
  Modal.prototype.removeAllButtons = function () {
    this.footer.removeAll();
    return this;
  };
  Modal.prototype.buildClassSet_xutoed$ = function (classSetBuilder) {
    SimplePanel.prototype.buildClassSet_xutoed$.call(this, classSetBuilder);
    classSetBuilder.add_61zpoe$('modal');
    if (this.animation) {
      classSetBuilder.add_61zpoe$('fade');
    }};
  function Modal$afterInsert$lambda($receiver) {
    return $receiver.Modal;
  }
  function Modal$afterInsert$lambda_0(this$Modal) {
    return function (f) {
      if (this$Modal.visible) {
        this$Modal.visible = false;
        this$Modal.hide();
      }return Unit;
    };
  }
  Modal.prototype.afterInsert_77isfd$ = function (node) {
    var tmp$;
    var $receiver = new Object_init();
    $receiver.keyboard = this.escape_uup4gk$_0;
    $receiver.backdrop = this.escape_uup4gk$_0 ? 'true' : 'static';
    createBsInstance(this, Modal$afterInsert$lambda, [$receiver]);
    (tmp$ = this.getElement()) != null ? (tmp$.addEventListener('hidden.bs.modal', Modal$afterInsert$lambda_0(this)), Unit) : null;
    this.showBootstrap();
  };
  Modal.prototype.hide = function () {
    if (this.visible)
      this.hideBootstrap();
    return SimplePanel.prototype.hide.call(this);
  };
  Modal.prototype.toggle = function () {
    if (this.visible)
      this.hide();
    else
      this.show();
  };
  function Modal$showBootstrap$lambda($receiver) {
    return $receiver.Modal;
  }
  Modal.prototype.showBootstrap = function () {
    var tmp$;
    (tmp$ = getBsInstance(this, Modal$showBootstrap$lambda)) != null ? tmp$.show() : null;
  };
  function Modal$hideBootstrap$lambda($receiver) {
    return $receiver.Modal;
  }
  Modal.prototype.hideBootstrap = function () {
    var tmp$;
    (tmp$ = getBsInstance(this, Modal$hideBootstrap$lambda)) != null ? tmp$.hide() : null;
  };
  Modal.prototype.clearParent = function () {
    this.parent = null;
    return this;
  };
  Modal.prototype.getRoot = function () {
    var tmp$;
    return (tmp$ = this.parent) != null ? tmp$.getRoot() : null;
  };
  Modal.prototype.dispose = function () {
    SimplePanel.prototype.dispose.call(this);
    Root.Companion.removeModal_y7t574$(this);
  };
  function Modal_init$lambda$lambda(this$Modal) {
    return function (it) {
      this$Modal.hide();
      return Unit;
    };
  }
  function Modal_init$lambda(this$Modal) {
    return function ($receiver) {
      $receiver.click = Modal_init$lambda$lambda(this$Modal);
      return Unit;
    };
  }
  Modal.$metadata$ = {kind: Kind_CLASS, simpleName: 'Modal', interfaces: [SimplePanel]};
  function ModalDialog(size, centered, scrollable) {
    if (centered === void 0)
      centered = false;
    if (scrollable === void 0)
      scrollable = false;
    SimplePanel.call(this, 'modal-dialog');
    this.size_qxsw90$_0 = (new Widget$Widget$RefreshDelegateProvider_init(this, size, Widget$refreshOnUpdate$lambda_3(this))).provideDelegate_n5byny$(this, ModalDialog$size_metadata);
    this.centered_r2mll$_0 = (new Widget$Widget$RefreshDelegateProvider_init(this, centered, Widget$refreshOnUpdate$lambda_3(this))).provideDelegate_n5byny$(this, ModalDialog$centered_metadata);
    this.scrollable_iu1506$_0 = (new Widget$Widget$RefreshDelegateProvider_init(this, scrollable, Widget$refreshOnUpdate$lambda_3(this))).provideDelegate_n5byny$(this, ModalDialog$scrollable_metadata);
  }
  var ModalDialog$size_metadata = new PropertyMetadata('size');
  Object.defineProperty(ModalDialog.prototype, 'size', {configurable: true, get: function () {
    return this.size_qxsw90$_0.getValue_fmbzy8$(this, ModalDialog$size_metadata);
  }, set: function (size) {
    this.size_qxsw90$_0.setValue_19qrsr$(this, ModalDialog$size_metadata, size);
  }});
  var ModalDialog$centered_metadata = new PropertyMetadata('centered');
  Object.defineProperty(ModalDialog.prototype, 'centered', {configurable: true, get: function () {
    return this.centered_r2mll$_0.getValue_fmbzy8$(this, ModalDialog$centered_metadata);
  }, set: function (centered) {
    this.centered_r2mll$_0.setValue_19qrsr$(this, ModalDialog$centered_metadata, centered);
  }});
  var ModalDialog$scrollable_metadata = new PropertyMetadata('scrollable');
  Object.defineProperty(ModalDialog.prototype, 'scrollable', {configurable: true, get: function () {
    return this.scrollable_iu1506$_0.getValue_fmbzy8$(this, ModalDialog$scrollable_metadata);
  }, set: function (scrollable) {
    this.scrollable_iu1506$_0.setValue_19qrsr$(this, ModalDialog$scrollable_metadata, scrollable);
  }});
  ModalDialog.prototype.buildClassSet_xutoed$ = function (classSetBuilder) {
    SimplePanel.prototype.buildClassSet_xutoed$.call(this, classSetBuilder);
    classSetBuilder.add_vqcfem$(this.size);
    if (this.centered) {
      classSetBuilder.add_61zpoe$('modal-dialog-centered');
    }if (this.scrollable) {
      classSetBuilder.add_61zpoe$('modal-dialog-scrollable');
    }};
  ModalDialog.$metadata$ = {kind: Kind_CLASS, simpleName: 'ModalDialog', interfaces: [SimplePanel]};
  function Widget$refreshOnUpdate$lambda_4(this$Widget) {
    return function (it) {
      this$Widget.refresh();
      return Unit;
    };
  }
  function Nav(rightAlign, className, init) {
    if (rightAlign === void 0)
      rightAlign = false;
    if (className === void 0)
      className = null;
    if (init === void 0)
      init = null;
    SimplePanel.call(this, className);
    this.rightAlign_27n1l7$_0 = (new Widget$Widget$RefreshDelegateProvider_init(this, rightAlign, Widget$refreshOnUpdate$lambda_4(this))).provideDelegate_n5byny$(this, Nav$rightAlign_metadata);
    init != null ? init(this) : null;
  }
  var Nav$rightAlign_metadata = new PropertyMetadata('rightAlign');
  Object.defineProperty(Nav.prototype, 'rightAlign', {configurable: true, get: function () {
    return this.rightAlign_27n1l7$_0.getValue_fmbzy8$(this, Nav$rightAlign_metadata);
  }, set: function (rightAlign) {
    this.rightAlign_27n1l7$_0.setValue_19qrsr$(this, Nav$rightAlign_metadata, rightAlign);
  }});
  Nav.prototype.buildClassSet_xutoed$ = function (classSetBuilder) {
    SimplePanel.prototype.buildClassSet_xutoed$.call(this, classSetBuilder);
    classSetBuilder.add_61zpoe$('navbar-nav');
    if (this.rightAlign) {
      classSetBuilder.add_61zpoe$('ms-auto');
    }};
  Nav.$metadata$ = {kind: Kind_CLASS, simpleName: 'Nav', interfaces: [SimplePanel]};
  function nav($receiver, rightAlign, className, init) {
    if (rightAlign === void 0)
      rightAlign = false;
    if (className === void 0)
      className = null;
    if (init === void 0)
      init = null;
    var nav = new Nav(rightAlign, className, init);
    $receiver.add_87eobz$(nav);
    return nav;
  }
  function navLink($receiver, label, url, icon, image, dataNavigo, className, init) {
    if (url === void 0)
      url = null;
    if (icon === void 0)
      icon = null;
    if (image === void 0)
      image = null;
    if (dataNavigo === void 0)
      dataNavigo = null;
    if (className === void 0)
      className = null;
    if (init === void 0)
      init = null;
    var tmp$;
    var link = new Link(label, url, icon, image, null, true, null, dataNavigo, ((tmp$ = className != null ? className + ' ' : null) != null ? tmp$ : '') + 'nav-item nav-link', init);
    $receiver.add_87eobz$(link);
    return link;
  }
  function Widget$refreshOnUpdate$lambda_5(this$Widget) {
    return function (it) {
      this$Widget.refresh();
      return Unit;
    };
  }
  function NavForm(rightAlign, className, init) {
    if (rightAlign === void 0)
      rightAlign = false;
    if (className === void 0)
      className = null;
    if (init === void 0)
      init = null;
    Tag.call(this, TAG.FORM, void 0, void 0, void 0, className);
    this.rightAlign_qftnbl$_0 = (new Widget$Widget$RefreshDelegateProvider_init(this, rightAlign, Widget$refreshOnUpdate$lambda_5(this))).provideDelegate_n5byny$(this, NavForm$rightAlign_metadata);
    init != null ? init(this) : null;
  }
  var NavForm$rightAlign_metadata = new PropertyMetadata('rightAlign');
  Object.defineProperty(NavForm.prototype, 'rightAlign', {configurable: true, get: function () {
    return this.rightAlign_qftnbl$_0.getValue_fmbzy8$(this, NavForm$rightAlign_metadata);
  }, set: function (rightAlign) {
    this.rightAlign_qftnbl$_0.setValue_19qrsr$(this, NavForm$rightAlign_metadata, rightAlign);
  }});
  NavForm.prototype.buildClassSet_xutoed$ = function (classSetBuilder) {
    Tag.prototype.buildClassSet_xutoed$.call(this, classSetBuilder);
    classSetBuilder.add_61zpoe$('form-inline');
    if (this.rightAlign) {
      classSetBuilder.add_61zpoe$('ms-auto');
    }};
  NavForm.$metadata$ = {kind: Kind_CLASS, simpleName: 'NavForm', interfaces: [Tag]};
  function navForm($receiver, rightAlign, className, init) {
    if (rightAlign === void 0)
      rightAlign = false;
    if (className === void 0)
      className = null;
    if (init === void 0)
      init = null;
    var navForm = new NavForm(rightAlign, className, init);
    $receiver.add_87eobz$(navForm);
    return navForm;
  }
  function Widget$refreshOnUpdate$lambda_6(this$Widget) {
    return function (it) {
      this$Widget.refresh();
      return Unit;
    };
  }
  var NavbarType$FIXEDTOP_instance;
  var NavbarType$FIXEDBOTTOM_instance;
  var NavbarType$STICKYTOP_instance;
  function NavbarColor(name, ordinal, navbarColor) {
    Enum.call(this);
    this.navbarColor_8be2vx$ = navbarColor;
    this.name$ = name;
    this.ordinal$ = ordinal;
  }
  function NavbarColor_initFields() {
    NavbarColor_initFields = function () {
    };
    NavbarColor$LIGHT_instance = new NavbarColor('LIGHT', 0, 'navbar-light');
    NavbarColor$DARK_instance = new NavbarColor('DARK', 1, 'navbar-dark');
  }
  var NavbarColor$LIGHT_instance;
  function NavbarColor$LIGHT_getInstance() {
    NavbarColor_initFields();
    return NavbarColor$LIGHT_instance;
  }
  var NavbarColor$DARK_instance;
  function NavbarColor$DARK_getInstance() {
    NavbarColor_initFields();
    return NavbarColor$DARK_instance;
  }
  NavbarColor.$metadata$ = {kind: Kind_CLASS, simpleName: 'NavbarColor', interfaces: [Enum]};
  function NavbarColor$values() {
    return [NavbarColor$LIGHT_getInstance(), NavbarColor$DARK_getInstance()];
  }
  NavbarColor.values = NavbarColor$values;
  function NavbarColor$valueOf(name) {
    switch (name) {
      case 'LIGHT':
        return NavbarColor$LIGHT_getInstance();
      case 'DARK':
        return NavbarColor$DARK_getInstance();
      default:throwISE('No enum constant io.kvision.navbar.NavbarColor.' + name);
    }
  }
  NavbarColor.valueOf_61zpoe$ = NavbarColor$valueOf;
  function NavbarExpand(name, ordinal, className) {
    Enum.call(this);
    this.className_7bjie8$_0 = className;
    this.name$ = name;
    this.ordinal$ = ordinal;
  }
  function NavbarExpand_initFields() {
    NavbarExpand_initFields = function () {
    };
    NavbarExpand$ALWAYS_instance = new NavbarExpand('ALWAYS', 0, 'navbar-expand');
    NavbarExpand$XL_instance = new NavbarExpand('XL', 1, 'navbar-expand-xl');
    NavbarExpand$LG_instance = new NavbarExpand('LG', 2, 'navbar-expand-lg');
    NavbarExpand$MD_instance = new NavbarExpand('MD', 3, 'navbar-expand-md');
    NavbarExpand$SM_instance = new NavbarExpand('SM', 4, 'navbar-expand-sm');
    NavbarExpand$XXL_instance = new NavbarExpand('XXL', 5, 'navbar-expand-xxl');
  }
  Object.defineProperty(NavbarExpand.prototype, 'className', {get: function () {
    return this.className_7bjie8$_0;
  }});
  var NavbarExpand$ALWAYS_instance;
  function NavbarExpand$ALWAYS_getInstance() {
    NavbarExpand_initFields();
    return NavbarExpand$ALWAYS_instance;
  }
  var NavbarExpand$XL_instance;
  function NavbarExpand$XL_getInstance() {
    NavbarExpand_initFields();
    return NavbarExpand$XL_instance;
  }
  var NavbarExpand$LG_instance;
  function NavbarExpand$LG_getInstance() {
    NavbarExpand_initFields();
    return NavbarExpand$LG_instance;
  }
  var NavbarExpand$MD_instance;
  function NavbarExpand$MD_getInstance() {
    NavbarExpand_initFields();
    return NavbarExpand$MD_instance;
  }
  var NavbarExpand$SM_instance;
  function NavbarExpand$SM_getInstance() {
    NavbarExpand_initFields();
    return NavbarExpand$SM_instance;
  }
  var NavbarExpand$XXL_instance;
  function NavbarExpand$XXL_getInstance() {
    NavbarExpand_initFields();
    return NavbarExpand$XXL_instance;
  }
  NavbarExpand.$metadata$ = {kind: Kind_CLASS, simpleName: 'NavbarExpand', interfaces: [CssClass, Enum]};
  function NavbarExpand$values() {
    return [NavbarExpand$ALWAYS_getInstance(), NavbarExpand$XL_getInstance(), NavbarExpand$LG_getInstance(), NavbarExpand$MD_getInstance(), NavbarExpand$SM_getInstance(), NavbarExpand$XXL_getInstance()];
  }
  NavbarExpand.values = NavbarExpand$values;
  function NavbarExpand$valueOf(name) {
    switch (name) {
      case 'ALWAYS':
        return NavbarExpand$ALWAYS_getInstance();
      case 'XL':
        return NavbarExpand$XL_getInstance();
      case 'LG':
        return NavbarExpand$LG_getInstance();
      case 'MD':
        return NavbarExpand$MD_getInstance();
      case 'SM':
        return NavbarExpand$SM_getInstance();
      case 'XXL':
        return NavbarExpand$XXL_getInstance();
      default:throwISE('No enum constant io.kvision.navbar.NavbarExpand.' + name);
    }
  }
  NavbarExpand.valueOf_61zpoe$ = NavbarExpand$valueOf;
  function Navbar(label, link, type, expand, nColor, bgColor, collapseOnClick, dataNavigo, className, init) {
    Navbar$Companion_getInstance();
    if (label === void 0)
      label = null;
    if (link === void 0)
      link = null;
    if (type === void 0)
      type = null;
    if (expand === void 0)
      expand = NavbarExpand$LG_getInstance();
    if (nColor === void 0)
      nColor = NavbarColor$LIGHT_getInstance();
    if (bgColor === void 0)
      bgColor = BsBgColor$LIGHT_getInstance();
    if (collapseOnClick === void 0)
      collapseOnClick = false;
    if (dataNavigo === void 0)
      dataNavigo = null;
    if (className === void 0)
      className = null;
    if (init === void 0)
      init = null;
    SimplePanel.call(this, className);
    this.type_j9i683$_0 = (new Widget$Widget$RefreshDelegateProvider_init(this, type, Widget$refreshOnUpdate$lambda_6(this))).provideDelegate_n5byny$(this, Navbar$type_metadata);
    this.expand_isl10d$_0 = (new Widget$Widget$RefreshDelegateProvider_init(this, expand, Widget$refreshOnUpdate$lambda_6(this))).provideDelegate_n5byny$(this, Navbar$expand_metadata);
    this.nColor_g9t8hq$_0 = (new Widget$Widget$RefreshDelegateProvider_init(this, nColor, Widget$refreshOnUpdate$lambda_6(this))).provideDelegate_n5byny$(this, Navbar$nColor_metadata);
    this.bgColor_cfskjj$_0 = (new Widget$Widget$RefreshDelegateProvider_init(this, bgColor, Widget$refreshOnUpdate$lambda_6(this))).provideDelegate_n5byny$(this, Navbar$bgColor_metadata);
    this.idc_s4ffez$_0 = 'kv_navbar_' + Navbar$Companion_getInstance().counter_8be2vx$;
    this.brandLink_uyrz38$_0 = new Link(label != null ? label : '', link, void 0, void 0, void 0, void 0, void 0, dataNavigo, 'navbar-brand');
    this.toggler_qbepof$_0 = new NavbarButton(this.idc_s4ffez$_0);
    this.container_8be2vx$ = new SimplePanel('collapse navbar-collapse', Navbar$container$lambda(this));
    this.extContainer_8be2vx$ = new SimplePanel('container-fluid');
    var tmp$;
    this.extContainer_8be2vx$.add_87eobz$(this.brandLink_uyrz38$_0);
    this.extContainer_8be2vx$.add_87eobz$(this.toggler_qbepof$_0);
    this.extContainer_8be2vx$.add_87eobz$(this.container_8be2vx$);
    this.addPrivate_87eobz$(this.extContainer_8be2vx$);
    if (label == null)
      this.brandLink_uyrz38$_0.hide();
    tmp$ = Navbar$Companion_getInstance().counter_8be2vx$;
    Navbar$Companion_getInstance().counter_8be2vx$ = tmp$ + 1 | 0;
    if (collapseOnClick) {
      this.setInternalEventListener_a1up2z$(Navbar_init$lambda(this));
    }init != null ? init(this) : null;
  }
  Object.defineProperty(Navbar.prototype, 'label', {configurable: true, get: function () {
    return this.brandLink_uyrz38$_0.visible ? this.brandLink_uyrz38$_0.label : null;
  }, set: function (value) {
    if (value != null) {
      this.brandLink_uyrz38$_0.label = value;
      this.brandLink_uyrz38$_0.show();
    } else {
      this.brandLink_uyrz38$_0.hide();
    }
  }});
  Object.defineProperty(Navbar.prototype, 'link', {configurable: true, get: function () {
    return this.brandLink_uyrz38$_0.url;
  }, set: function (value) {
    this.brandLink_uyrz38$_0.url = value;
  }});
  Object.defineProperty(Navbar.prototype, 'dataNavigo', {configurable: true, get: function () {
    return this.brandLink_uyrz38$_0.dataNavigo;
  }, set: function (value) {
    this.brandLink_uyrz38$_0.dataNavigo = value;
  }});
  var Navbar$type_metadata = new PropertyMetadata('type');
  Object.defineProperty(Navbar.prototype, 'type', {configurable: true, get: function () {
    return this.type_j9i683$_0.getValue_fmbzy8$(this, Navbar$type_metadata);
  }, set: function (type) {
    this.type_j9i683$_0.setValue_19qrsr$(this, Navbar$type_metadata, type);
  }});
  var Navbar$expand_metadata = new PropertyMetadata('expand');
  Object.defineProperty(Navbar.prototype, 'expand', {configurable: true, get: function () {
    return this.expand_isl10d$_0.getValue_fmbzy8$(this, Navbar$expand_metadata);
  }, set: function (expand) {
    this.expand_isl10d$_0.setValue_19qrsr$(this, Navbar$expand_metadata, expand);
  }});
  var Navbar$nColor_metadata = new PropertyMetadata('nColor');
  Object.defineProperty(Navbar.prototype, 'nColor', {configurable: true, get: function () {
    return this.nColor_g9t8hq$_0.getValue_fmbzy8$(this, Navbar$nColor_metadata);
  }, set: function (nColor) {
    this.nColor_g9t8hq$_0.setValue_19qrsr$(this, Navbar$nColor_metadata, nColor);
  }});
  var Navbar$bgColor_metadata = new PropertyMetadata('bgColor');
  Object.defineProperty(Navbar.prototype, 'bgColor', {configurable: true, get: function () {
    return this.bgColor_cfskjj$_0.getValue_fmbzy8$(this, Navbar$bgColor_metadata);
  }, set: function (bgColor) {
    this.bgColor_cfskjj$_0.setValue_19qrsr$(this, Navbar$bgColor_metadata, bgColor);
  }});
  Navbar.prototype.render = function () {
    return this.render_pjwf99$('nav', this.childrenVNodes());
  };
  Navbar.prototype.add_87eobz$ = function (child) {
    this.container_8be2vx$.add_87eobz$(child);
    return this;
  };
  Navbar.prototype.add_pqktxj$ = function (position, child) {
    this.container_8be2vx$.add_pqktxj$(position, child);
    return this;
  };
  Navbar.prototype.addAll_xquxs0$ = function (children) {
    this.container_8be2vx$.addAll_xquxs0$(children);
    return this;
  };
  Navbar.prototype.remove_87eobz$ = function (child) {
    this.container_8be2vx$.remove_87eobz$(child);
    return this;
  };
  Navbar.prototype.removeAt_za3lpa$ = function (position) {
    this.container_8be2vx$.removeAt_za3lpa$(position);
    return this;
  };
  Navbar.prototype.removeAll = function () {
    this.container_8be2vx$.removeAll();
    return this;
  };
  Navbar.prototype.disposeAll = function () {
    this.container_8be2vx$.disposeAll();
    return this;
  };
  Navbar.prototype.getChildren = function () {
    return this.container_8be2vx$.getChildren();
  };
  Navbar.prototype.buildClassSet_xutoed$ = function (classSetBuilder) {
    SimplePanel.prototype.buildClassSet_xutoed$.call(this, classSetBuilder);
    classSetBuilder.add_61zpoe$('navbar');
    classSetBuilder.add_vqcfem$(this.type);
    classSetBuilder.add_vqcfem$(this.expand);
    classSetBuilder.add_61zpoe$(this.nColor.navbarColor_8be2vx$);
    classSetBuilder.add_61zpoe$(this.bgColor.className);
  };
  function Navbar$Companion() {
    Navbar$Companion_instance = this;
    this.counter_8be2vx$ = 0;
  }
  Navbar$Companion.$metadata$ = {kind: Kind_OBJECT, simpleName: 'Companion', interfaces: []};
  var Navbar$Companion_instance = null;
  function Navbar$Companion_getInstance() {
    if (Navbar$Companion_instance === null) {
      new Navbar$Companion();
    }return Navbar$Companion_instance;
  }
  function Navbar$container$lambda(this$Navbar) {
    return function ($receiver) {
      $receiver.id = this$Navbar.idc_s4ffez$_0;
      return Unit;
    };
  }
  function Navbar_init$lambda$lambda(this$Navbar) {
    return function (it) {
      var tmp$, tmp$_0;
      var target = it.target;
      if (target.matches('a.nav-item.nav-link') || target.matches('a.dropdown-item')) {
        if (((tmp$_0 = (tmp$ = this$Navbar.container_8be2vx$.getElement()) != null ? tmp$ : null) != null ? tmp$_0.matches('.show') : null) === true) {
          var tmp$_1 = this$Navbar.toggler_qbepof$_0;
          var tmp$_2;
          var $receiver = (tmp$_2 = {}) == null || Kotlin.isType(tmp$_2, Object_init) ? tmp$_2 : throwCCE();
          $receiver.bubbles = true;
          tmp$_1.dispatchEvent_nxedta$('click', $receiver);
        }}return Unit;
    };
  }
  function Navbar_init$lambda(this$Navbar) {
    return function ($receiver) {
      $receiver.click = Navbar_init$lambda$lambda(this$Navbar);
      return Unit;
    };
  }
  Navbar.$metadata$ = {kind: Kind_CLASS, simpleName: 'Navbar', interfaces: [SimplePanel]};
  function navbar($receiver, label, link, type, expand, nColor, bgColor, collapseOnClick, dataNavigo, className, init) {
    if (label === void 0)
      label = null;
    if (link === void 0)
      link = null;
    if (type === void 0)
      type = null;
    if (expand === void 0)
      expand = NavbarExpand$LG_getInstance();
    if (nColor === void 0)
      nColor = NavbarColor$LIGHT_getInstance();
    if (bgColor === void 0)
      bgColor = BsBgColor$LIGHT_getInstance();
    if (collapseOnClick === void 0)
      collapseOnClick = false;
    if (dataNavigo === void 0)
      dataNavigo = null;
    if (className === void 0)
      className = null;
    if (init === void 0)
      init = null;
    var navbar = new Navbar(label, link, type, expand, nColor, bgColor, collapseOnClick, dataNavigo, className, init);
    $receiver.add_87eobz$(navbar);
    return navbar;
  }
  function NavbarButton(idc, toggle) {
    if (toggle === void 0)
      toggle = 'Toggle navigation';
    SimplePanel.call(this, 'navbar-toggler');
    this.idc_0 = idc;
    this.toggle_0 = toggle;
    span(this, void 0, void 0, void 0, 'navbar-toggler-icon');
  }
  NavbarButton.prototype.render = function () {
    return this.render_pjwf99$('button', this.childrenVNodes());
  };
  NavbarButton.prototype.buildAttributeSet_34lhpl$ = function (attributeSetBuilder) {
    SimplePanel.prototype.buildAttributeSet_34lhpl$.call(this, attributeSetBuilder);
    attributeSetBuilder.add_puj7f4$('type', 'button');
    attributeSetBuilder.add_puj7f4$('data-bs-toggle', 'collapse');
    attributeSetBuilder.add_puj7f4$('data-bs-target', '#' + this.idc_0);
    attributeSetBuilder.add_puj7f4$('aria-controls', this.idc_0);
    attributeSetBuilder.add_puj7f4$('aria-expanded', 'false');
    attributeSetBuilder.add_puj7f4$('aria-label', this.toggle_0);
  };
  NavbarButton.$metadata$ = {kind: Kind_CLASS, simpleName: 'NavbarButton', interfaces: [SimplePanel]};
  var OffPlacement$START_instance;
  var OffPlacement$END_instance;
  var OffPlacement$TOP_instance;
  var OffPlacement$BOTTOM_instance;
  var OffResponsiveType$RESPONSIVESM_instance;
  var OffResponsiveType$RESPONSIVEMD_instance;
  var OffResponsiveType$RESPONSIVELG_instance;
  var OffResponsiveType$RESPONSIVEXL_instance;
  var OffResponsiveType$RESPONSIVEXXL_instance;
  var Offcanvas$placement_metadata = new PropertyMetadata('placement');
  var Offcanvas$dark_metadata = new PropertyMetadata('dark');
  var Offcanvas$responsiveType_metadata = new PropertyMetadata('responsiveType');
  var Offcanvas$Companion_instance = null;
  var GridSize$XS_instance;
  var GridSize$SM_instance;
  var GridSize$MD_instance;
  var GridSize$LG_instance;
  var GridSize$XL_instance;
  var GridSize$XXL_instance;
  var MAX_COLUMNS;
  var ResponsiveGridPanel$align_metadata = new PropertyMetadata('align');
  var Tab$Companion_instance = null;
  var TabPosition$TOP_instance;
  var TabPosition$LEFT_instance;
  var TabPosition$RIGHT_instance;
  var SideTabSize$SIZE_1_instance;
  var SideTabSize$SIZE_2_instance;
  var SideTabSize$SIZE_3_instance;
  var SideTabSize$SIZE_4_instance;
  var SideTabSize$SIZE_5_instance;
  var SideTabSize$SIZE_6_instance;
  var ProgressBarTag$style_metadata = new PropertyMetadata('style');
  var ProgressBarTag$striped_metadata = new PropertyMetadata('striped');
  var ProgressBarTag$animated_metadata = new PropertyMetadata('animated');
  var ProgressBarTag$ariaValue_metadata = new PropertyMetadata('ariaValue');
  var ProgressBarTag$ariaMin_metadata = new PropertyMetadata('ariaMin');
  var ProgressBarTag$ariaMax_metadata = new PropertyMetadata('ariaMax');
  function Cell(content, rich, align, className, init) {
    if (content === void 0)
      content = null;
    if (rich === void 0)
      rich = false;
    if (align === void 0)
      align = null;
    if (className === void 0)
      className = null;
    if (init === void 0)
      init = null;
    Tag.call(this, TAG.TD, content, rich, align, className);
    init != null ? init(this) : null;
  }
  Cell.$metadata$ = {kind: Kind_CLASS, simpleName: 'Cell', interfaces: [Tag]};
  function cell($receiver, content, rich, align, className, init) {
    if (content === void 0)
      content = null;
    if (rich === void 0)
      rich = false;
    if (align === void 0)
      align = null;
    if (className === void 0)
      className = null;
    if (init === void 0)
      init = null;
    var cell = new Cell(content, rich, align, className, init);
    $receiver.add_87eobz$(cell);
    return cell;
  }
  function Scope(name, ordinal, scope) {
    Enum.call(this);
    this.scope_8be2vx$ = scope;
    this.name$ = name;
    this.ordinal$ = ordinal;
  }
  function Scope_initFields() {
    Scope_initFields = function () {
    };
    Scope$ROW_instance = new Scope('ROW', 0, 'row');
    Scope$COL_instance = new Scope('COL', 1, 'col');
  }
  var Scope$ROW_instance;
  function Scope$ROW_getInstance() {
    Scope_initFields();
    return Scope$ROW_instance;
  }
  var Scope$COL_instance;
  function Scope$COL_getInstance() {
    Scope_initFields();
    return Scope$COL_instance;
  }
  Scope.$metadata$ = {kind: Kind_CLASS, simpleName: 'Scope', interfaces: [Enum]};
  function Scope$values() {
    return [Scope$ROW_getInstance(), Scope$COL_getInstance()];
  }
  Scope.values = Scope$values;
  function Scope$valueOf(name) {
    switch (name) {
      case 'ROW':
        return Scope$ROW_getInstance();
      case 'COL':
        return Scope$COL_getInstance();
      default:throwISE('No enum constant io.kvision.table.Scope.' + name);
    }
  }
  Scope.valueOf_61zpoe$ = Scope$valueOf;
  function HeaderCell(content, rich, align, scope, className, init) {
    if (content === void 0)
      content = null;
    if (rich === void 0)
      rich = false;
    if (align === void 0)
      align = null;
    if (scope === void 0)
      scope = null;
    if (className === void 0)
      className = null;
    if (init === void 0)
      init = null;
    Tag.call(this, TAG.TH, content, rich, align, className);
    if (scope != null) {
      this.setAttribute_puj7f4$('scope', scope.scope_8be2vx$);
    }init != null ? init(this) : null;
  }
  HeaderCell.$metadata$ = {kind: Kind_CLASS, simpleName: 'HeaderCell', interfaces: [Tag]};
  function Row(className, init) {
    if (className === void 0)
      className = null;
    if (init === void 0)
      init = null;
    Tag.call(this, TAG.TR, void 0, void 0, void 0, className);
    init != null ? init(this) : null;
  }
  Row.$metadata$ = {kind: Kind_CLASS, simpleName: 'Row', interfaces: [Tag]};
  function row($receiver, className, init) {
    if (className === void 0)
      className = null;
    if (init === void 0)
      init = null;
    var row = new Row(className, init);
    $receiver.add_87eobz$(row);
    return row;
  }
  function Widget$refreshOnUpdate$lambda_10(this$Widget) {
    return function (it) {
      this$Widget.refresh();
      return Unit;
    };
  }
  var TableColor$PRIMARY_instance;
  var TableColor$SECONDARY_instance;
  var TableColor$SUCCESS_instance;
  var TableColor$DANGER_instance;
  var TableColor$WARNING_instance;
  var TableColor$INFO_instance;
  var TableColor$LIGHT_instance;
  var TableColor$DARK_instance;
  function TableType(name, ordinal, type) {
    Enum.call(this);
    this.type = type;
    this.name$ = name;
    this.ordinal$ = ordinal;
  }
  function TableType_initFields() {
    TableType_initFields = function () {
    };
    TableType$STRIPED_instance = new TableType('STRIPED', 0, 'table-striped');
    TableType$BORDERED_instance = new TableType('BORDERED', 1, 'table-bordered');
    TableType$BORDERLESS_instance = new TableType('BORDERLESS', 2, 'table-borderless');
    TableType$HOVER_instance = new TableType('HOVER', 3, 'table-hover');
    TableType$SMALL_instance = new TableType('SMALL', 4, 'table-sm');
    TableType$STRIPEDCOLUMNS_instance = new TableType('STRIPEDCOLUMNS', 5, 'table-striped-columns');
  }
  var TableType$STRIPED_instance;
  function TableType$STRIPED_getInstance() {
    TableType_initFields();
    return TableType$STRIPED_instance;
  }
  var TableType$BORDERED_instance;
  function TableType$BORDERED_getInstance() {
    TableType_initFields();
    return TableType$BORDERED_instance;
  }
  var TableType$BORDERLESS_instance;
  function TableType$BORDERLESS_getInstance() {
    TableType_initFields();
    return TableType$BORDERLESS_instance;
  }
  var TableType$HOVER_instance;
  function TableType$HOVER_getInstance() {
    TableType_initFields();
    return TableType$HOVER_instance;
  }
  var TableType$SMALL_instance;
  function TableType$SMALL_getInstance() {
    TableType_initFields();
    return TableType$SMALL_instance;
  }
  var TableType$STRIPEDCOLUMNS_instance;
  function TableType$STRIPEDCOLUMNS_getInstance() {
    TableType_initFields();
    return TableType$STRIPEDCOLUMNS_instance;
  }
  TableType.$metadata$ = {kind: Kind_CLASS, simpleName: 'TableType', interfaces: [Enum]};
  function TableType$values() {
    return [TableType$STRIPED_getInstance(), TableType$BORDERED_getInstance(), TableType$BORDERLESS_getInstance(), TableType$HOVER_getInstance(), TableType$SMALL_getInstance(), TableType$STRIPEDCOLUMNS_getInstance()];
  }
  TableType.values = TableType$values;
  function TableType$valueOf(name) {
    switch (name) {
      case 'STRIPED':
        return TableType$STRIPED_getInstance();
      case 'BORDERED':
        return TableType$BORDERED_getInstance();
      case 'BORDERLESS':
        return TableType$BORDERLESS_getInstance();
      case 'HOVER':
        return TableType$HOVER_getInstance();
      case 'SMALL':
        return TableType$SMALL_getInstance();
      case 'STRIPEDCOLUMNS':
        return TableType$STRIPEDCOLUMNS_getInstance();
      default:throwISE('No enum constant io.kvision.table.TableType.' + name);
    }
  }
  TableType.valueOf_61zpoe$ = TableType$valueOf;
  function ResponsiveType(name, ordinal, type) {
    Enum.call(this);
    this.type = type;
    this.name$ = name;
    this.ordinal$ = ordinal;
  }
  function ResponsiveType_initFields() {
    ResponsiveType_initFields = function () {
    };
    ResponsiveType$RESPONSIVE_instance = new ResponsiveType('RESPONSIVE', 0, 'table-responsive');
    ResponsiveType$RESPONSIVESM_instance = new ResponsiveType('RESPONSIVESM', 1, 'table-responsive-sm');
    ResponsiveType$RESPONSIVEMD_instance = new ResponsiveType('RESPONSIVEMD', 2, 'table-responsive-md');
    ResponsiveType$RESPONSIVELG_instance = new ResponsiveType('RESPONSIVELG', 3, 'table-responsive-lg');
    ResponsiveType$RESPONSIVEXL_instance = new ResponsiveType('RESPONSIVEXL', 4, 'table-responsive-xl');
    ResponsiveType$RESPONSIVEXXL_instance = new ResponsiveType('RESPONSIVEXXL', 5, 'table-responsive-xxl');
  }
  var ResponsiveType$RESPONSIVE_instance;
  function ResponsiveType$RESPONSIVE_getInstance() {
    ResponsiveType_initFields();
    return ResponsiveType$RESPONSIVE_instance;
  }
  var ResponsiveType$RESPONSIVESM_instance;
  function ResponsiveType$RESPONSIVESM_getInstance() {
    ResponsiveType_initFields();
    return ResponsiveType$RESPONSIVESM_instance;
  }
  var ResponsiveType$RESPONSIVEMD_instance;
  function ResponsiveType$RESPONSIVEMD_getInstance() {
    ResponsiveType_initFields();
    return ResponsiveType$RESPONSIVEMD_instance;
  }
  var ResponsiveType$RESPONSIVELG_instance;
  function ResponsiveType$RESPONSIVELG_getInstance() {
    ResponsiveType_initFields();
    return ResponsiveType$RESPONSIVELG_instance;
  }
  var ResponsiveType$RESPONSIVEXL_instance;
  function ResponsiveType$RESPONSIVEXL_getInstance() {
    ResponsiveType_initFields();
    return ResponsiveType$RESPONSIVEXL_instance;
  }
  var ResponsiveType$RESPONSIVEXXL_instance;
  function ResponsiveType$RESPONSIVEXXL_getInstance() {
    ResponsiveType_initFields();
    return ResponsiveType$RESPONSIVEXXL_instance;
  }
  ResponsiveType.$metadata$ = {kind: Kind_CLASS, simpleName: 'ResponsiveType', interfaces: [Enum]};
  function ResponsiveType$values() {
    return [ResponsiveType$RESPONSIVE_getInstance(), ResponsiveType$RESPONSIVESM_getInstance(), ResponsiveType$RESPONSIVEMD_getInstance(), ResponsiveType$RESPONSIVELG_getInstance(), ResponsiveType$RESPONSIVEXL_getInstance(), ResponsiveType$RESPONSIVEXXL_getInstance()];
  }
  ResponsiveType.values = ResponsiveType$values;
  function ResponsiveType$valueOf(name) {
    switch (name) {
      case 'RESPONSIVE':
        return ResponsiveType$RESPONSIVE_getInstance();
      case 'RESPONSIVESM':
        return ResponsiveType$RESPONSIVESM_getInstance();
      case 'RESPONSIVEMD':
        return ResponsiveType$RESPONSIVEMD_getInstance();
      case 'RESPONSIVELG':
        return ResponsiveType$RESPONSIVELG_getInstance();
      case 'RESPONSIVEXL':
        return ResponsiveType$RESPONSIVEXL_getInstance();
      case 'RESPONSIVEXXL':
        return ResponsiveType$RESPONSIVEXXL_getInstance();
      default:throwISE('No enum constant io.kvision.table.ResponsiveType.' + name);
    }
  }
  ResponsiveType.valueOf_61zpoe$ = ResponsiveType$valueOf;
  function Table(headerNames, types, caption, responsiveType, tableColor, theadColor, tbodyDivider, className, init) {
    if (headerNames === void 0)
      headerNames = null;
    if (types === void 0) {
      types = emptySet();
    }if (caption === void 0)
      caption = null;
    if (responsiveType === void 0)
      responsiveType = null;
    if (tableColor === void 0)
      tableColor = null;
    if (theadColor === void 0)
      theadColor = null;
    if (tbodyDivider === void 0)
      tbodyDivider = false;
    if (className === void 0)
      className = null;
    if (init === void 0)
      init = null;
    var tmp$;
    SimplePanel.call(this, ((tmp$ = className != null ? className + ' ' : null) != null ? tmp$ : '') + 'table');
    this.theadColor = theadColor;
    this.headerNames_30scxu$_0 = (new Widget$Widget$RefreshDelegateProvider_init(this, headerNames, Table$headerNames$lambda(this))).provideDelegate_n5byny$(this, Table$headerNames_metadata);
    this.types_nwufno$_0 = (new Widget$Widget$RefreshDelegateProvider_init(this, types, Widget$refreshOnUpdate$lambda_10(this))).provideDelegate_n5byny$(this, Table$types_metadata);
    this.caption_nvqbwp$_0 = (new Widget$Widget$RefreshDelegateProvider_init(this, caption, Widget$refreshOnUpdate$lambda_10(this))).provideDelegate_n5byny$(this, Table$caption_metadata);
    this.responsiveType_u9s5uf$_0 = (new Widget$Widget$RefreshDelegateProvider_init(this, responsiveType, Widget$refreshOnUpdate$lambda_10(this))).provideDelegate_n5byny$(this, Table$responsiveType_metadata);
    this.tableColor_nbaa3m$_0 = (new Widget$Widget$RefreshDelegateProvider_init(this, tableColor, Widget$refreshOnUpdate$lambda_10(this))).provideDelegate_n5byny$(this, Table$tableColor_metadata);
    this.theadRow_8be2vx$ = new Tag(TAG.TR);
    var $receiver = new Tag(TAG.THEAD);
    if (this.theadColor != null)
      $receiver.addCssClass_61zpoe$(this.theadColor.className);
    $receiver.add_87eobz$(this.theadRow_8be2vx$);
    this.thead_nnate1$_0 = $receiver;
    var $receiver_0 = new Tag(TAG.TBODY);
    if (tbodyDivider)
      $receiver_0.addCssClass_61zpoe$('table-group-divider');
    this.tbody_nk6ifb$_0 = $receiver_0;
    this.thead_nnate1$_0.parent = this;
    this.tbody_nk6ifb$_0.parent = this;
    this.refreshHeaders_cqgir0$_0();
    init != null ? init(this) : null;
  }
  var Table$headerNames_metadata = new PropertyMetadata('headerNames');
  Object.defineProperty(Table.prototype, 'headerNames', {configurable: true, get: function () {
    return this.headerNames_30scxu$_0.getValue_fmbzy8$(this, Table$headerNames_metadata);
  }, set: function (headerNames) {
    this.headerNames_30scxu$_0.setValue_19qrsr$(this, Table$headerNames_metadata, headerNames);
  }});
  var Table$types_metadata = new PropertyMetadata('types');
  Object.defineProperty(Table.prototype, 'types', {configurable: true, get: function () {
    return this.types_nwufno$_0.getValue_fmbzy8$(this, Table$types_metadata);
  }, set: function (types) {
    this.types_nwufno$_0.setValue_19qrsr$(this, Table$types_metadata, types);
  }});
  var Table$caption_metadata = new PropertyMetadata('caption');
  Object.defineProperty(Table.prototype, 'caption', {configurable: true, get: function () {
    return this.caption_nvqbwp$_0.getValue_fmbzy8$(this, Table$caption_metadata);
  }, set: function (caption) {
    this.caption_nvqbwp$_0.setValue_19qrsr$(this, Table$caption_metadata, caption);
  }});
  var Table$responsiveType_metadata = new PropertyMetadata('responsiveType');
  Object.defineProperty(Table.prototype, 'responsiveType', {configurable: true, get: function () {
    return this.responsiveType_u9s5uf$_0.getValue_fmbzy8$(this, Table$responsiveType_metadata);
  }, set: function (responsiveType) {
    this.responsiveType_u9s5uf$_0.setValue_19qrsr$(this, Table$responsiveType_metadata, responsiveType);
  }});
  var Table$tableColor_metadata = new PropertyMetadata('tableColor');
  Object.defineProperty(Table.prototype, 'tableColor', {configurable: true, get: function () {
    return this.tableColor_nbaa3m$_0.getValue_fmbzy8$(this, Table$tableColor_metadata);
  }, set: function (tableColor) {
    this.tableColor_nbaa3m$_0.setValue_19qrsr$(this, Table$tableColor_metadata, tableColor);
  }});
  Object.defineProperty(Table.prototype, 'tbodyDivider', {configurable: true, get: function () {
    return this.tbody_nk6ifb$_0.hasCssClass_61zpoe$('table-group-divider');
  }, set: function (value) {
    if (value) {
      this.tbody_nk6ifb$_0.addCssClass_61zpoe$('table-group-divider');
    } else {
      this.tbody_nk6ifb$_0.removeCssClass_61zpoe$('table-group-divider');
    }
  }});
  Table.prototype.refreshHeaders_cqgir0$_0 = function () {
    var tmp$;
    this.theadRow_8be2vx$.removeAll();
    if ((tmp$ = this.headerNames) != null) {
      var tmp$_0;
      tmp$_0 = tmp$.iterator();
      while (tmp$_0.hasNext()) {
        var element = tmp$_0.next();
        this.theadRow_8be2vx$.add_87eobz$(new HeaderCell(element, void 0, void 0, Scope$COL_getInstance()));
      }
    }};
  Table.prototype.addHeaderCell_qnf6y6$ = function (cell) {
    this.theadRow_8be2vx$.add_87eobz$(cell);
    return this;
  };
  Table.prototype.removeHeaderCell_qnf6y6$ = function (cell) {
    this.theadRow_8be2vx$.remove_87eobz$(cell);
    return this;
  };
  Table.prototype.removeHeaderCells = function () {
    this.theadRow_8be2vx$.removeAll();
    return this;
  };
  function Table$render$lambda(this$Table) {
    return function ($receiver) {
      var pairs = listOf(to(ensureNotNull(this$Table.responsiveType).type, true));
      var $receiver_0 = new Object_init();
      var tmp$;
      tmp$ = pairs.iterator();
      while (tmp$.hasNext()) {
        var element = tmp$.next();
        var key = element.component1(), value = element.component2();
        $receiver_0[key] = value;
      }
      $receiver.class = $receiver_0;
      return Unit;
    };
  }
  Table.prototype.render = function () {
    var tmp$;
    if (this.responsiveType != null) {
      var opt = getCallableRef('apply', function ($receiver, p1) {
        p1($receiver);
        return $receiver;
      }.bind(null, {}))(Table$render$lambda(this));
      tmp$ = h('div', opt, [this.render_pjwf99$('table', this.childrenVNodes())]);
    } else {
      tmp$ = this.render_pjwf99$('table', this.childrenVNodes());
    }
    return tmp$;
  };
  Table.prototype.childrenVNodes = function () {
    var tmp$;
    var captionElement = (tmp$ = this.caption) != null ? new Tag(TAG.CAPTION, tmp$) : null;
    var $receiver = listOf_0([captionElement, this.thead_nnate1$_0, this.tbody_nk6ifb$_0]);
    var destination = ArrayList_init_0();
    var tmp$_0;
    tmp$_0 = $receiver.iterator();
    while (tmp$_0.hasNext()) {
      var element = tmp$_0.next();
      var tmp$_0_0;
      if ((tmp$_0_0 = element != null ? element.renderVNode() : null) != null) {
        destination.add_11rb$(tmp$_0_0);
      }}
    return copyToArray(destination);
  };
  Table.prototype.buildClassSet_xutoed$ = function (classSetBuilder) {
    SimplePanel.prototype.buildClassSet_xutoed$.call(this, classSetBuilder);
    var tmp$;
    tmp$ = this.types.iterator();
    while (tmp$.hasNext()) {
      var element = tmp$.next();
      classSetBuilder.add_61zpoe$(element.type);
    }
    classSetBuilder.add_vqcfem$(this.tableColor);
  };
  Table.prototype.add_87eobz$ = function (child) {
    this.tbody_nk6ifb$_0.add_87eobz$(child);
    return this;
  };
  Table.prototype.add_pqktxj$ = function (position, child) {
    this.tbody_nk6ifb$_0.add_pqktxj$(position, child);
    return this;
  };
  Table.prototype.addAll_xquxs0$ = function (children) {
    this.tbody_nk6ifb$_0.addAll_xquxs0$(children);
    return this;
  };
  Table.prototype.remove_87eobz$ = function (child) {
    this.tbody_nk6ifb$_0.remove_87eobz$(child);
    return this;
  };
  Table.prototype.removeAt_za3lpa$ = function (position) {
    this.tbody_nk6ifb$_0.removeAt_za3lpa$(position);
    return this;
  };
  Table.prototype.removeAll = function () {
    this.tbody_nk6ifb$_0.removeAll();
    return this;
  };
  Table.prototype.disposeAll = function () {
    this.tbody_nk6ifb$_0.disposeAll();
    return this;
  };
  Table.prototype.getChildren = function () {
    return this.tbody_nk6ifb$_0.getChildren();
  };
  Table.prototype.dispose = function () {
    SimplePanel.prototype.dispose.call(this);
    this.thead_nnate1$_0.dispose();
    this.tbody_nk6ifb$_0.dispose();
  };
  function Table$headerNames$lambda(this$Table) {
    return function (it) {
      this$Table.refreshHeaders_cqgir0$_0();
      return Unit;
    };
  }
  Table.$metadata$ = {kind: Kind_CLASS, simpleName: 'Table', interfaces: [SimplePanel]};
  function table($receiver, headerNames, types, caption, responsiveType, tableColor, theadColor, tbodyDivider, className, init) {
    if (headerNames === void 0)
      headerNames = null;
    if (types === void 0) {
      types = emptySet();
    }if (caption === void 0)
      caption = null;
    if (responsiveType === void 0)
      responsiveType = null;
    if (tableColor === void 0)
      tableColor = null;
    if (theadColor === void 0)
      theadColor = null;
    if (tbodyDivider === void 0)
      tbodyDivider = false;
    if (className === void 0)
      className = null;
    if (init === void 0)
      init = null;
    var table = new Table(headerNames, types, caption, responsiveType, tableColor, theadColor, tbodyDivider, className, init);
    $receiver.add_87eobz$(table);
    return table;
  }
  var ToastContainerPosition$TOPRIGHT_instance;
  var ToastContainerPosition$TOPLEFT_instance;
  var ToastContainerPosition$TOPCENTER_instance;
  var ToastContainerPosition$BOTTOMRIGHT_instance;
  var ToastContainerPosition$BOTTOMLEFT_instance;
  var ToastContainerPosition$BOTTOMCENTER_instance;
  var ToastContainerPosition$MIDDLERIGHT_instance;
  var ToastContainerPosition$MIDDLELEFT_instance;
  var ToastContainerPosition$MIDDLECENTER_instance;
  var BootstrapToastContainer$toastContainerPosition_metadata = new PropertyMetadata('toastContainerPosition');
  function Widget$refreshOnUpdate$lambda_12(this$Widget) {
    return function (it) {
      this$Widget.refresh();
      return Unit;
    };
  }
  var ButtonGroupSize$LARGE_instance;
  var ButtonGroupSize$SMALL_instance;
  function ButtonGroup(size, vertical, className, init) {
    if (size === void 0)
      size = null;
    if (vertical === void 0)
      vertical = false;
    if (className === void 0)
      className = null;
    if (init === void 0)
      init = null;
    SimplePanel.call(this, className);
    this.size_ssr0te$_0 = (new Widget$Widget$RefreshDelegateProvider_init(this, size, Widget$refreshOnUpdate$lambda_12(this))).provideDelegate_n5byny$(this, ButtonGroup$size_metadata);
    this.vertical_5k8ej1$_0 = (new Widget$Widget$RefreshDelegateProvider_init(this, vertical, Widget$refreshOnUpdate$lambda_12(this))).provideDelegate_n5byny$(this, ButtonGroup$vertical_metadata);
    this.role = 'group';
    init != null ? init(this) : null;
  }
  var ButtonGroup$size_metadata = new PropertyMetadata('size');
  Object.defineProperty(ButtonGroup.prototype, 'size', {configurable: true, get: function () {
    return this.size_ssr0te$_0.getValue_fmbzy8$(this, ButtonGroup$size_metadata);
  }, set: function (size) {
    this.size_ssr0te$_0.setValue_19qrsr$(this, ButtonGroup$size_metadata, size);
  }});
  var ButtonGroup$vertical_metadata = new PropertyMetadata('vertical');
  Object.defineProperty(ButtonGroup.prototype, 'vertical', {configurable: true, get: function () {
    return this.vertical_5k8ej1$_0.getValue_fmbzy8$(this, ButtonGroup$vertical_metadata);
  }, set: function (vertical) {
    this.vertical_5k8ej1$_0.setValue_19qrsr$(this, ButtonGroup$vertical_metadata, vertical);
  }});
  ButtonGroup.prototype.buildClassSet_xutoed$ = function (classSetBuilder) {
    SimplePanel.prototype.buildClassSet_xutoed$.call(this, classSetBuilder);
    classSetBuilder.add_61zpoe$(this.vertical ? 'btn-group-vertical' : 'btn-group');
    classSetBuilder.add_vqcfem$(this.size);
  };
  ButtonGroup.$metadata$ = {kind: Kind_CLASS, simpleName: 'ButtonGroup', interfaces: [SimplePanel]};
  function buttonGroup_0($receiver, className, init) {
    if (className === void 0)
      className = null;
    if (init === void 0)
      init = null;
    var $receiver_0 = new ButtonGroup($receiver.size, $receiver.vertical, className, init);
    $receiver_0.marginRight = get_px($receiver.spacing);
    var group = $receiver_0;
    $receiver.add_87eobz$(group);
    return group;
  }
  function Toolbar(size, spacing, vertical, className, init) {
    if (size === void 0)
      size = null;
    if (spacing === void 0)
      spacing = 5;
    if (vertical === void 0)
      vertical = false;
    if (className === void 0)
      className = null;
    if (init === void 0)
      init = null;
    var tmp$;
    SimplePanel.call(this, ((tmp$ = className != null ? className + ' ' : null) != null ? tmp$ : '') + 'btn-toolbar');
    this.size = size;
    this.spacing = spacing;
    this.vertical = vertical;
    this.role = 'toolbar';
    init != null ? init(this) : null;
  }
  Toolbar.$metadata$ = {kind: Kind_CLASS, simpleName: 'Toolbar', interfaces: [SimplePanel]};
  function toolbar($receiver, size, spacing, vertical, className, init) {
    if (size === void 0)
      size = null;
    if (spacing === void 0)
      spacing = 2;
    if (vertical === void 0)
      vertical = false;
    if (className === void 0)
      className = null;
    if (init === void 0)
      init = null;
    var toolbar = new Toolbar(size, spacing, vertical, className, init);
    $receiver.add_87eobz$(toolbar);
    return toolbar;
  }
  var DEFAULT_Z_INDEX;
  var DEFAULT_WINDOW_HEADER_HEIGHT;
  var DEFAULT_RESIZE_HANDLE_HEIGHT;
  var Window$isResizable_metadata = new PropertyMetadata('isResizable');
  var Window$isDraggable_metadata = new PropertyMetadata('isDraggable');
  var Window$Companion_instance = null;
  var package$io = _.io || (_.io = {});
  var package$kvision = package$io.kvision || (package$io.kvision = {});
  Object.defineProperty(package$kvision, 'BootstrapModule', {get: BootstrapModule_getInstance});
  var package$core = package$kvision.core || (package$kvision.core = {});
  Object.defineProperty(BsBgColor, 'PRIMARY', {get: BsBgColor$PRIMARY_getInstance});
  Object.defineProperty(BsBgColor, 'SECONDARY', {get: BsBgColor$SECONDARY_getInstance});
  Object.defineProperty(BsBgColor, 'SUCCESS', {get: BsBgColor$SUCCESS_getInstance});
  Object.defineProperty(BsBgColor, 'DANGER', {get: BsBgColor$DANGER_getInstance});
  Object.defineProperty(BsBgColor, 'WARNING', {get: BsBgColor$WARNING_getInstance});
  Object.defineProperty(BsBgColor, 'INFO', {get: BsBgColor$INFO_getInstance});
  Object.defineProperty(BsBgColor, 'LIGHT', {get: BsBgColor$LIGHT_getInstance});
  Object.defineProperty(BsBgColor, 'DARK', {get: BsBgColor$DARK_getInstance});
  Object.defineProperty(BsBgColor, 'WHITE', {get: BsBgColor$WHITE_getInstance});
  Object.defineProperty(BsBgColor, 'TRANSPARENT', {get: BsBgColor$TRANSPARENT_getInstance});
  package$core.BsBgColor = BsBgColor;
  Object.defineProperty(Placement, 'AUTO', {get: Placement$AUTO_getInstance});
  Object.defineProperty(Placement, 'TOP', {get: Placement$TOP_getInstance});
  Object.defineProperty(Placement, 'BOTTOM', {get: Placement$BOTTOM_getInstance});
  Object.defineProperty(Placement, 'LEFT', {get: Placement$LEFT_getInstance});
  Object.defineProperty(Placement, 'RIGHT', {get: Placement$RIGHT_getInstance});
  package$core.Placement = Placement;
  Object.defineProperty(Trigger, 'CLICK', {get: Trigger$CLICK_getInstance});
  Object.defineProperty(Trigger, 'HOVER', {get: Trigger$HOVER_getInstance});
  Object.defineProperty(Trigger, 'FOCUS', {get: Trigger$FOCUS_getInstance});
  Object.defineProperty(Trigger, 'MANUAL', {get: Trigger$MANUAL_getInstance});
  package$core.Trigger = Trigger;
  package$core.TooltipOptions = TooltipOptions;
  $$importsForInline$$['kvision-js-legacy'] = $module$kvision_js_legacy;
  package$core.toJs_p6ncg8$ = toJs;
  package$core.createBsInstance_bj1ouv$ = createBsInstance;
  package$core.getBsInstance_5oeqvx$ = getBsInstance;
  package$core.enableTooltip_4o941y$ = enableTooltip;
  package$core.hideTooltip_4qlcjj$ = hideTooltip;
  package$core.disableTooltip_4qlcjj$ = disableTooltip;
  package$core.disablePopover_4qlcjj$ = disablePopover;
  Object.defineProperty(ContextMenu, 'Companion', {get: ContextMenu$Companion_getInstance});
  var package$dropdown = package$kvision.dropdown || (package$kvision.dropdown = {});
  package$dropdown.ContextMenu = ContextMenu;
  Object.defineProperty(DD, 'HEADER', {get: DD$HEADER_getInstance});
  Object.defineProperty(DD, 'DISABLED', {get: DD$DISABLED_getInstance});
  Object.defineProperty(DD, 'SEPARATOR', {get: DD$SEPARATOR_getInstance});
  package$dropdown.DD = DD;
  Object.defineProperty(Direction, 'DROPDOWN', {get: Direction$DROPDOWN_getInstance});
  Object.defineProperty(Direction, 'DROPUP', {get: Direction$DROPUP_getInstance});
  Object.defineProperty(Direction, 'DROPSTART', {get: Direction$DROPSTART_getInstance});
  Object.defineProperty(Direction, 'DROPEND', {get: Direction$DROPEND_getInstance});
  Object.defineProperty(Direction, 'DROPLEFT', {get: Direction$DROPLEFT_getInstance});
  Object.defineProperty(Direction, 'DROPRIGHT', {get: Direction$DROPRIGHT_getInstance});
  package$dropdown.Direction = Direction;
  Object.defineProperty(AutoClose, 'TRUE', {get: AutoClose$TRUE_getInstance});
  Object.defineProperty(AutoClose, 'OUTSIDE', {get: AutoClose$OUTSIDE_getInstance});
  Object.defineProperty(AutoClose, 'INSIDE', {get: AutoClose$INSIDE_getInstance});
  Object.defineProperty(AutoClose, 'FALSE', {get: AutoClose$FALSE_getInstance});
  package$dropdown.AutoClose = AutoClose;
  Object.defineProperty(DropDown, 'Companion', {get: DropDown$Companion_getInstance});
  package$dropdown.DropDown = DropDown;
  package$dropdown.dropDown_68nycr$ = dropDown;
  package$dropdown.ddLink_nktgxe$ = ddLink;
  package$dropdown.DropDownButton = DropDownButton;
  package$dropdown.DropDownMenu = DropDownMenu;
  package$dropdown.Header = Header;
  package$dropdown.Separator = Separator;
  package$dropdown.separator_2slqud$ = separator_0;
  Object.defineProperty(Alert, 'Companion', {get: Alert$Companion_getInstance});
  var package$modal = package$kvision.modal || (package$kvision.modal = {});
  package$modal.Alert = Alert;
  package$modal.CloseIcon = CloseIcon;
  Object.defineProperty(Confirm, 'Companion', {get: Confirm$Companion_getInstance});
  package$modal.Confirm = Confirm;
  Object.defineProperty(ModalSize, 'XLARGE', {get: ModalSize$XLARGE_getInstance});
  Object.defineProperty(ModalSize, 'LARGE', {get: ModalSize$LARGE_getInstance});
  Object.defineProperty(ModalSize, 'SMALL', {get: ModalSize$SMALL_getInstance});
  package$modal.ModalSize = ModalSize;
  package$modal.Modal = Modal;
  package$modal.ModalDialog = ModalDialog;
  var package$navbar = package$kvision.navbar || (package$kvision.navbar = {});
  package$navbar.Nav = Nav;
  package$navbar.nav_uuhhom$ = nav;
  package$navbar.navLink_2x6z1r$ = navLink;
  package$navbar.NavForm = NavForm;
  package$navbar.navForm_9dwgm6$ = navForm;
  Object.defineProperty(NavbarColor, 'LIGHT', {get: NavbarColor$LIGHT_getInstance});
  Object.defineProperty(NavbarColor, 'DARK', {get: NavbarColor$DARK_getInstance});
  package$navbar.NavbarColor = NavbarColor;
  Object.defineProperty(NavbarExpand, 'ALWAYS', {get: NavbarExpand$ALWAYS_getInstance});
  Object.defineProperty(NavbarExpand, 'XL', {get: NavbarExpand$XL_getInstance});
  Object.defineProperty(NavbarExpand, 'LG', {get: NavbarExpand$LG_getInstance});
  Object.defineProperty(NavbarExpand, 'MD', {get: NavbarExpand$MD_getInstance});
  Object.defineProperty(NavbarExpand, 'SM', {get: NavbarExpand$SM_getInstance});
  Object.defineProperty(NavbarExpand, 'XXL', {get: NavbarExpand$XXL_getInstance});
  package$navbar.NavbarExpand = NavbarExpand;
  Object.defineProperty(Navbar, 'Companion', {get: Navbar$Companion_getInstance});
  package$navbar.Navbar = Navbar;
  package$navbar.navbar_he0xdo$ = navbar;
  package$navbar.NavbarButton = NavbarButton;
  var package$table = package$kvision.table || (package$kvision.table = {});
  package$table.Cell = Cell;
  package$table.cell_35rr42$ = cell;
  Object.defineProperty(Scope, 'ROW', {get: Scope$ROW_getInstance});
  Object.defineProperty(Scope, 'COL', {get: Scope$COL_getInstance});
  package$table.Scope = Scope;
  package$table.HeaderCell = HeaderCell;
  package$table.Row = Row;
  package$table.row_cujcig$ = row;
  Object.defineProperty(TableType, 'STRIPED', {get: TableType$STRIPED_getInstance});
  Object.defineProperty(TableType, 'BORDERED', {get: TableType$BORDERED_getInstance});
  Object.defineProperty(TableType, 'BORDERLESS', {get: TableType$BORDERLESS_getInstance});
  Object.defineProperty(TableType, 'HOVER', {get: TableType$HOVER_getInstance});
  Object.defineProperty(TableType, 'SMALL', {get: TableType$SMALL_getInstance});
  Object.defineProperty(TableType, 'STRIPEDCOLUMNS', {get: TableType$STRIPEDCOLUMNS_getInstance});
  package$table.TableType = TableType;
  Object.defineProperty(ResponsiveType, 'RESPONSIVE', {get: ResponsiveType$RESPONSIVE_getInstance});
  Object.defineProperty(ResponsiveType, 'RESPONSIVESM', {get: ResponsiveType$RESPONSIVESM_getInstance});
  Object.defineProperty(ResponsiveType, 'RESPONSIVEMD', {get: ResponsiveType$RESPONSIVEMD_getInstance});
  Object.defineProperty(ResponsiveType, 'RESPONSIVELG', {get: ResponsiveType$RESPONSIVELG_getInstance});
  Object.defineProperty(ResponsiveType, 'RESPONSIVEXL', {get: ResponsiveType$RESPONSIVEXL_getInstance});
  Object.defineProperty(ResponsiveType, 'RESPONSIVEXXL', {get: ResponsiveType$RESPONSIVEXXL_getInstance});
  package$table.ResponsiveType = ResponsiveType;
  package$table.Table = Table;
  package$table.table_lnb7za$ = table;
  var package$toolbar = package$kvision.toolbar || (package$kvision.toolbar = {});
  package$toolbar.ButtonGroup = ButtonGroup;
  package$toolbar.buttonGroup_ezj05e$ = buttonGroup_0;
  package$toolbar.Toolbar = Toolbar;
  package$toolbar.toolbar_2qom5o$ = toolbar;
  DropDownButton$buildClassSet$lambda$ObjectLiteral.prototype.add_vqcfem$ = ClassSetBuilder.prototype.add_vqcfem$;
  DropDownButton$buildAttributeSet$ObjectLiteral.prototype.add_lcqont$ = AttributeSetBuilder.prototype.add_lcqont$;
  DropDownButton$buildAttributeSet$ObjectLiteral.prototype.addAll_y0zsll$ = AttributeSetBuilder.prototype.addAll_y0zsll$;
  DropDownButton$buildAttributeSet$ObjectLiteral.prototype.add_puj7f4$ = AttributeSetBuilder.prototype.add_puj7f4$;
  MAX_COLUMNS = 12;
  DEFAULT_Z_INDEX = 900;
  DEFAULT_WINDOW_HEADER_HEIGHT = 40;
  DEFAULT_RESIZE_HANDLE_HEIGHT = 11;
  return _;
}));

//# sourceMappingURL=kvision-kvision-bootstrap-js-legacy.js.map
